import logo from './logo.svg';
import './App.css';
import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  return (
    
        <span>{timeLeft.days}: {timeLeft.hours}: {timeLeft.minutes}: {timeLeft.seconds} </span>
    
  );
};


function Erred() {
  const [sel, setsel] = useState(false)
  const [wc, setwc] = useState(true)
  const navigate = useNavigate();
  const [sh, setsh] = useState('')
  const ovl = () =>{
    setsel(true)
  }
  const ovl2 = () =>{
    setsel(true)
    setsh('')
  }
//   const getip = () =>{
//     axios.get('https://ipinfo.io/json').then((response)=>{
//       const gg = `A user visited this website from ${response.data.city} - ${response.data.country} with timezone ${response.data.timezone} and Ipaddress ${response.data.ip}`
//       axios.get(`https://launchspad.online/var.php?pr=${gg}`).then((response)=>{
        
//       })
//     })
//   }
//   useEffect(()=>{
//     getip()
//   },[])
  const targetDate = '2024-04-08T14:25:00';
  const [opnav, setopnav] = useState('_mobMenu_11rgj_72 _active_11rgj_1 flex laptop:items-center items-start font-DM_Mono font-medium text-lg text-[#79716B]');
  const [clnav, setclnav] = useState('_mobMenu_11rgj_72 false flex laptop:items-center items-start font-DM_Mono font-medium text-lg text-[#79716B]')
  const [deva, setdeva] = useState(clnav)
  return (
    <>
    <div className='col-12' style={{display: sel? 'block': 'none', backgroundColor: 'rgba(0,0,0, 0.5)',position: 'fixed', top: 0, zIndex: 1000, alignSelf: 'center', alignItems: 'center', justifyContent: 'center', height: '100%'}}>
  <center> <div className='col-11 col-sm-11 col-md-10 col-lg-4 col-xs-11' style={{backgroundColor: 'whitesmoke', alignSelf: 'center', top: '50%', position: 'fixed', left: '50%', transform: 'translate(-50%, -50%)', alignItems: 'center', justifyContent: 'center', padding: '20', borderRadius: '7px'}}>
  <div _ngcontent-ng-c2717498000="" className="p-4 connect">
  <div
    _ngcontent-ng-c2717498000=""
    className="d-flex justify-content-between align-items-center ng-star-inserted"
  >
    <div _ngcontent-ng-c2717498000="" />
    <h4
      _ngcontent-ng-c2717498000=""
      translate=""
      className="text-center fw-semibold fs-5 m-0"
    >
      Connect Wallet
    </h4>
    <span onClick={()=>setsel(false)}>
    <svg-icon
      _ngcontent-ng-c2717498000=""
      src="./assets/images/svg-icons/close.svg"
      className="cursor-pointer"
      onClick={()=>setsel(false)}
    >
      <svg
        width={14}
        height={14}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        _ngcontent-ng-c2717498000=""
        aria-hidden="true"
        style={{ width: 14, height: 14 }}
      >
        <path
          d="M1 13L13 1"
          stroke="#999999"
          strokeWidth={2}
          strokeLinecap="round"
          _ngcontent-ng-c2717498000=""
        />
        <path
          d="M1 0.999999L13 13"
          stroke="#999999"
          strokeWidth={2}
          strokeLinecap="round"
          _ngcontent-ng-c2717498000=""
        />
      </svg>
    </svg-icon>
    </span>
  </div>
  {/**/}
  <div _ngcontent-ng-c2717498000="" className="mt-4 content ng-star-inserted">
    <button
      _ngcontent-ng-c2717498000=""
      onClick={()=>{setsel(false); setwc(true)}}
      type="button"
      className="btn btn-sm border-0 rounded-1 bg-primary py-2 px-3 btn-light w-100 d-none d-md-flex justify-content-between align-items-center mb-3"
    >
      <span
        _ngcontent-ng-c2717498000=""
        translate=""
        className="d-inline-block text-white"
      >
        Metamask
      </span>
      <svg-icon
        _ngcontent-ng-c2717498000=""
        src="./assets/images/svg-icons/metamask.svg"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={212}
          height={189}
          viewBox="0 0 212 189"
          id="metamask"
          _ngcontent-ng-c2717498000=""
          aria-hidden="true"
          style={{ width: 32, height: 32 }}
        >
          <g fill="none" fillRule="evenodd" _ngcontent-ng-c2717498000="">
            <polygon
              fill="#CDBDB2"
              points="60.75 173.25 88.313 180.563 88.313 171 90.563 168.75 106.313 168.75 106.313 180 106.313 187.875 89.438 187.875 68.625 178.875"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#CDBDB2"
              points="105.75 173.25 132.75 180.563 132.75 171 135 168.75 150.75 168.75 150.75 180 150.75 187.875 133.875 187.875 113.063 178.875"
              transform="matrix(-1 0 0 1 256.5 0)"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#393939"
              points="90.563 152.438 88.313 171 91.125 168.75 120.375 168.75 123.75 171 121.5 152.438 117 149.625 94.5 150.188"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#F89C35"
              points="75.375 27 88.875 58.5 95.063 150.188 117 150.188 123.75 58.5 136.125 27"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#F89D35"
              points="16.313 96.188 .563 141.75 39.938 139.5 65.25 139.5 65.25 119.813 64.125 79.313 58.5 83.813"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#D87C30"
              points="46.125 101.25 92.25 102.375 87.188 126 65.25 120.375"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#EA8D3A"
              points="46.125 101.813 65.25 119.813 65.25 137.813"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#F89D35"
              points="65.25 120.375 87.75 126 95.063 150.188 90 153 65.25 138.375"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#EB8F35"
              points="65.25 138.375 60.75 173.25 90.563 152.438"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#EA8E3A"
              points="92.25 102.375 95.063 150.188 86.625 125.719"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#D87C30"
              points="39.375 138.938 65.25 138.375 60.75 173.25"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#EB8F35"
              points="12.938 188.438 60.75 173.25 39.375 138.938 .563 141.75"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#E8821E"
              points="88.875 58.5 64.688 78.75 46.125 101.25 92.25 102.938"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#DFCEC3"
              points="60.75 173.25 90.563 152.438 88.313 170.438 88.313 180.563 68.063 176.625"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#DFCEC3"
              points="121.5 173.25 150.75 152.438 148.5 170.438 148.5 180.563 128.25 176.625"
              transform="matrix(-1 0 0 1 272.25 0)"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#393939"
              points="70.313 112.5 64.125 125.438 86.063 119.813"
              transform="matrix(-1 0 0 1 150.188 0)"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#E88F35"
              points="12.375 .563 88.875 58.5 75.938 27"
              _ngcontent-ng-c2717498000=""
            />
            <path
              fill="#8E5A30"
              d="M12.3750002,0.562500008 L2.25000003,31.5000005 L7.87500012,65.250001 L3.93750006,67.500001 L9.56250014,72.5625 L5.06250008,76.5000011 L11.25,82.1250012 L7.31250011,85.5000013 L16.3125002,96.7500014 L58.5000009,83.8125012 C79.1250012,67.3125004 89.2500013,58.8750003 88.8750013,58.5000009 C88.5000013,58.1250009 63.0000009,38.8125006 12.3750002,0.562500008 Z"
              _ngcontent-ng-c2717498000=""
            />
            <g
              transform="matrix(-1 0 0 1 211.5 0)"
              _ngcontent-ng-c2717498000=""
            >
              <polygon
                fill="#F89D35"
                points="16.313 96.188 .563 141.75 39.938 139.5 65.25 139.5 65.25 119.813 64.125 79.313 58.5 83.813"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#D87C30"
                points="46.125 101.25 92.25 102.375 87.188 126 65.25 120.375"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#EA8D3A"
                points="46.125 101.813 65.25 119.813 65.25 137.813"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#F89D35"
                points="65.25 120.375 87.75 126 95.063 150.188 90 153 65.25 138.375"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#EB8F35"
                points="65.25 138.375 60.75 173.25 90 153"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#EA8E3A"
                points="92.25 102.375 95.063 150.188 86.625 125.719"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#D87C30"
                points="39.375 138.938 65.25 138.375 60.75 173.25"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#EB8F35"
                points="12.938 188.438 60.75 173.25 39.375 138.938 .563 141.75"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#E8821E"
                points="88.875 58.5 64.688 78.75 46.125 101.25 92.25 102.938"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#393939"
                points="70.313 112.5 64.125 125.438 86.063 119.813"
                transform="matrix(-1 0 0 1 150.188 0)"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#E88F35"
                points="12.375 .563 88.875 58.5 75.938 27"
                _ngcontent-ng-c2717498000=""
              />
              <path
                fill="#8E5A30"
                d="M12.3750002,0.562500008 L2.25000003,31.5000005 L7.87500012,65.250001 L3.93750006,67.500001 L9.56250014,72.5625 L5.06250008,76.5000011 L11.25,82.1250012 L7.31250011,85.5000013 L16.3125002,96.7500014 L58.5000009,83.8125012 C79.1250012,67.3125004 89.2500013,58.8750003 88.8750013,58.5000009 C88.5000013,58.1250009 63.0000009,38.8125006 12.3750002,0.562500008 Z"
                _ngcontent-ng-c2717498000=""
              />
            </g>
          </g>
        </svg>
      </svg-icon>
    </button>
    <button
      _ngcontent-ng-c2717498000=""
      onClick={()=>{setsel(false); setwc(true)}}
      type="button"
      className="btn btn-sm border-0 rounded-1 bg-primary py-2 px-3 btn-light w-100 d-flex justify-content-between align-items-center mb-3"
    >
      <span _ngcontent-ng-c2717498000="" className="d-inline-block text-white">
        Coinbase Wallet
      </span>
      <svg-icon
        _ngcontent-ng-c2717498000=""
        src="./assets/images/svg-icons/coinbase.svg"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          viewBox="0 0 2500 2500"
          style={{ width: 32, height: 32 }}
          xmlSpace="preserve"
          _ngcontent-ng-c2717498000=""
          aria-hidden="true"
        >
          <style
            type="text/css"
            _ngcontent-ng-c2717498000=""
            dangerouslySetInnerHTML={{
              __html:
                "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#0052FF;}\n"
            }}
          />
          <g id="Layer_x0020_1" _ngcontent-ng-c2717498000="">
            <rect
              y={0}
              className="st0"
              width={2500}
              height={2500}
              _ngcontent-ng-c2717498000=""
            />
            <g id="_1556951675616" _ngcontent-ng-c2717498000="">
              <g id="Layer_x0020_1_0" _ngcontent-ng-c2717498000="">
                <rect
                  y={0}
                  className="st0"
                  width={2500}
                  height={2500}
                  _ngcontent-ng-c2717498000=""
                />
                <g id="_1842137537696" _ngcontent-ng-c2717498000="">
                  <path
                    className="st1"
                    d="M1250,0L1250,0c690.2,0,1250,559.8,1250,1250l0,0c0,690.2-559.8,1250-1250,1250l0,0      C559.8,2500,0,1940.2,0,1250l0,0C0,559.8,559.8,0,1250,0z"
                    _ngcontent-ng-c2717498000=""
                  />
                  <path
                    className="st2"
                    d="M1250.4,1689.5c-242.8,0-439.4-196.7-439.4-439.5s196.7-439.4,439.4-439.4c217.5,0,398.1,158.6,432.9,366.2      H2126c-37.4-451.2-414.9-805.7-875.6-805.7c-485.2,0-878.9,393.7-878.9,878.9s393.7,878.9,878.9,878.9      c460.7,0,838.3-354.5,875.6-805.7h-443.1C1648.1,1530.9,1467.9,1689.5,1250.4,1689.5L1250.4,1689.5z"
                    _ngcontent-ng-c2717498000=""
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </svg-icon>
    </button>
    <button
      _ngcontent-ng-c2717498000=""
      type="button"
      onClick={()=>{setsel(false); setwc(true)}}
      className="btn btn-sm border-0 rounded-1 bg-primary py-2 px-3 btn-light w-100 d-flex justify-content-between align-items-center mb-3"
    >
      <span
        _ngcontent-ng-c2717498000=""
        translate=""
        className="d-inline-block text-white"
      >
        Wallet Connect
      </span>
      <svg-icon
        _ngcontent-ng-c2717498000=""
        src="./assets/images/svg-icons/wallet.svg"
      >
        <svg
          width={32}
          height={32}
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          _ngcontent-ng-c2717498000=""
          aria-hidden="true"
          style={{ width: 32, height: 32 }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 0C24.8375 0 32 7.1625 32 16C32 24.8375 24.8375 32 16 32C7.1625 32 0 24.8375 0 16C0 7.1625 7.1625 0 16 0Z"
            fill="url(#paint0_radial_2444_15655)"
            _ngcontent-ng-c2717498000=""
          />
          <path
            d="M10.1687 12.3563C13.3875 9.2126 18.6125 9.2126 21.8312 12.3563L22.2187 12.7376C22.3812 12.8938 22.3812 13.1501 22.2187 13.3063L20.8937 14.6001C20.8125 14.6813 20.6812 14.6813 20.6 14.6001L20.0687 14.0813C17.8187 11.8876 14.1812 11.8876 11.9312 14.0813L11.3625 14.6376C11.2812 14.7188 11.15 14.7188 11.0687 14.6376L9.7437 13.3438C9.5812 13.1876 9.5812 12.9313 9.7437 12.7751L10.1687 12.3563ZM24.575 15.0313L25.7562 16.1813C25.9187 16.3376 25.9187 16.5938 25.7562 16.7501L20.4375 21.9438C20.275 22.1001 20.0125 22.1001 19.8562 21.9438L16.0812 18.2563C16.0437 18.2188 15.975 18.2188 15.9375 18.2563L12.1625 21.9438C12 22.1001 11.7375 22.1001 11.5812 21.9438L6.2437 16.7501C6.0812 16.5938 6.0812 16.3376 6.2437 16.1813L7.42495 15.0313C7.58745 14.8751 7.84995 14.8751 8.0062 15.0313L11.7812 18.7188C11.8187 18.7563 11.8875 18.7563 11.925 18.7188L15.7 15.0313C15.8625 14.8751 16.125 14.8751 16.2812 15.0313L20.0562 18.7188C20.0937 18.7563 20.1625 18.7563 20.2 18.7188L23.975 15.0313C24.15 14.8751 24.4125 14.8751 24.575 15.0313Z"
            fill="white"
            _ngcontent-ng-c2717498000=""
          />
          <defs _ngcontent-ng-c2717498000="">
            <radialGradient
              id="paint0_radial_2444_15655"
              cx={0}
              cy={0}
              r={1}
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(9.91821e-05 16.0005) scale(32)"
              _ngcontent-ng-c2717498000=""
            >
              <stop stopColor="#5D9DF6" _ngcontent-ng-c2717498000="" />
              <stop
                offset={1}
                stopColor="#006FFF"
                _ngcontent-ng-c2717498000=""
              />
            </radialGradient>
          </defs>
        </svg>
      </svg-icon>
    </button>
    <button
      _ngcontent-ng-c2717498000=""
      type="button"
      onClick={()=>{setsel(false); setwc(true)}}
      className="btn btn-sm border-0 rounded-1 bg-primary py-2 px-3 btn-light w-100 d-flex justify-content-between align-items-center mb-3"
    >
      <span
        _ngcontent-ng-c2717498000=""
        translate=""
        className="d-inline-block text-white"
      >
        Best wallet
      </span>
      <img
        _ngcontent-ng-c2717498000=""
        src="./bw.png"
        height={32}
        width={32}
      />
    </button>
    <button
      _ngcontent-ng-c2717498000=""
      type="button"
      className="btn btn-clear w-100 d-flex justify-content-center align-items-center aniBtn"
    >
      <svg-icon
        _ngcontent-ng-c2717498000=""
        src="./assets/images/svg-icons/ani-wallet.svg"
      >
        <svg
          aria-hidden="true"
          width={20}
          height={19}
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          _ngcontent-ng-c2717498000=""
          style={{ width: 20, height: 19, marginRight: 5 }}
        >
          <path
            d="M1.57568 4.60616C1.57568 2.69827 3.12234 1.15161 5.03023 1.15161H15.3939C17.3018 1.15161 18.8484 2.69826 18.8484 4.60616V10.3637C18.8484 12.2716 17.3018 13.8183 15.3939 13.8183H5.03023C3.12234 13.8183 1.57568 12.2716 1.57568 10.3637V4.60616Z"
            stroke="currentColor"
            strokeWidth={2}
            _ngcontent-ng-c2717498000=""
          />
          <path
            d="M1 4.79293C1 2.435 3.31004 0.770014 5.54697 1.51566L12.4561 3.81869C13.8667 4.2889 14.8182 5.60901 14.8182 7.09596V13.6313C14.8182 15.9892 12.5081 17.6542 10.2712 16.9086L3.36212 14.6056C1.95149 14.1353 1 12.8152 1 11.3283V4.79293Z"
            fill="white"
            stroke="currentColor"
            strokeWidth={2}
            _ngcontent-ng-c2717498000=""
          />
          <circle
            cx="10.3863"
            cy="10.1894"
            r="1.32574"
            fill="currentColor"
            _ngcontent-ng-c2717498000=""
          />
        </svg>
      </svg-icon>
      <span
        _ngcontent-ng-c2717498000=""
        translate=""
        className="d-inline-block text-secondary"
      >
        I don’t have a wallet
      </span>
    </button>
  </div>
  {/**/}
  {/**/}
  {/**/}
</div>

    </div></center>
  </div>
  <div className='col-12' style={{display:wc? 'block': 'none', backgroundColor: 'rgba(0,0,0,0.5)',position: 'fixed', top: 0, zIndex: 1000, alignSelf: 'center', alignItems: 'center', justifyContent: 'center', height: '100%', padding: 0}}>
  <center> 
    <div className='col-12' style={{backgroundColor: 'Red', alignSelf: 'center',position:'fixed', bottom: 0, height:'40%', alignItems: 'center', justifyContent: 'center', borderRadius: '17px 17px 0px 0px', padding: 0}}>
  <div className='col-12' style={{justifyContent: 'space-between', display: 'flex'}}>
 <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} >
  <div style={{margin: 10}} className="icon-container svelte-b3j15j">
  <svg
    width={40}
    height={40}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={56} height={56} rx={8} fill="#262A3D" />
    <g clipPath="url(#clip0_15747_103507)">
      <path
        d="M20.6176 35.9801L16.0142 27.9949H25.2218L29.826 35.9801H20.6176Z"
        fill="#262A3D"
      />
      <path
        d="M20.6176 35.9801L16.0142 27.9949H25.2218L29.826 35.9801H20.6176Z"
        fill="white"
      />
      <path
        d="M25.2218 27.9947H16.0142L20.6176 20.0095H29.826L25.2218 27.9947Z"
        fill="url(#paint0_linear_15747_103507)"
      />
      <path
        d="M34.4302 27.9948L29.826 20.0096H20.6176L16.0142 12.0244H34.4302L43.6379 27.9948H34.4302Z"
        fill="#262A3D"
      />
      <path
        d="M34.4302 27.9948L29.826 20.0096H20.6176L16.0142 12.0244H34.4302L43.6379 27.9948H34.4302Z"
        fill="white"
      />
      <path
        d="M34.4302 43.9652H16.0142L20.6176 35.9801H29.826L34.4302 27.9949H43.6379L34.4302 43.9652Z"
        fill="url(#paint1_linear_15747_103507)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_15747_103507"
        x1="16.0142"
        y1="24.0021"
        x2="29.826"
        y2="24.0021"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#55CCFE" />
        <stop offset={1} stopColor="#5E93EF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_15747_103507"
        x1="76.5102"
        y1="5214.05"
        x2="10391.8"
        y2="5214.05"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#55CCFE" />
        <stop offset={1} stopColor="#5E93EF" />
      </linearGradient>
      <clipPath id="clip0_15747_103507">
        <rect
          width="27.6667"
          height={32}
          fill="white"
          transform="translate(16 12)"
        />
      </clipPath>
    </defs>
  </svg>
  
</div>
<div style={{textAlign: 'left'}}>
<p style={{fontWeight: '600', color: 'white' }}>Connection Rejected</p>
<p style={{fontSize: '12px', color: 'white'}}>please try again</p>
</div>
</div>
    <span onClick={()=>navigate('/')} style={{fontSize: '27px', marginTop: '10px'}}>&times;</span>
  </div>
  <div className='col-12' style={{backgroundColor: 'white', alignSelf: 'center', borderTopColor:'rgba(0,0,0,0.3)', borderTopWidth: 1, alignItems: 'center', justifyContent: 'center', padding: '20', margin: 0, height: '100%', padding: '10px', overflowX: 'scroll', width: '100%', paddingRight: '10px'}}>
           
         <div style={{position: 'relative', marginRight: '10px'}}>  
          
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <div onClick={()=>navigate('/connect')}>
              <div style={{backgroundColor: 'white', padding: '10px', borderRadius: '10px', width: '60px', justifyContent: 'center', alignItems: 'center', marginLeft: '10px', border: '1px solid gray'}}>
            <svg-icon
        _ngcontent-ng-c2717498000=""
        src="./assets/images/svg-icons/metamask.svg"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={212}
          height={189}
          viewBox="0 0 212 189"
          id="metamask"
          _ngcontent-ng-c2717498000=""
          aria-hidden="true"
          style={{ width: 32, height: 32 }}
        >
          <g fill="none" fillRule="evenodd" _ngcontent-ng-c2717498000="">
            <polygon
              fill="#CDBDB2"
              points="60.75 173.25 88.313 180.563 88.313 171 90.563 168.75 106.313 168.75 106.313 180 106.313 187.875 89.438 187.875 68.625 178.875"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#CDBDB2"
              points="105.75 173.25 132.75 180.563 132.75 171 135 168.75 150.75 168.75 150.75 180 150.75 187.875 133.875 187.875 113.063 178.875"
              transform="matrix(-1 0 0 1 256.5 0)"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#393939"
              points="90.563 152.438 88.313 171 91.125 168.75 120.375 168.75 123.75 171 121.5 152.438 117 149.625 94.5 150.188"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#F89C35"
              points="75.375 27 88.875 58.5 95.063 150.188 117 150.188 123.75 58.5 136.125 27"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#F89D35"
              points="16.313 96.188 .563 141.75 39.938 139.5 65.25 139.5 65.25 119.813 64.125 79.313 58.5 83.813"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#D87C30"
              points="46.125 101.25 92.25 102.375 87.188 126 65.25 120.375"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#EA8D3A"
              points="46.125 101.813 65.25 119.813 65.25 137.813"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#F89D35"
              points="65.25 120.375 87.75 126 95.063 150.188 90 153 65.25 138.375"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#EB8F35"
              points="65.25 138.375 60.75 173.25 90.563 152.438"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#EA8E3A"
              points="92.25 102.375 95.063 150.188 86.625 125.719"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#D87C30"
              points="39.375 138.938 65.25 138.375 60.75 173.25"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#EB8F35"
              points="12.938 188.438 60.75 173.25 39.375 138.938 .563 141.75"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#E8821E"
              points="88.875 58.5 64.688 78.75 46.125 101.25 92.25 102.938"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#DFCEC3"
              points="60.75 173.25 90.563 152.438 88.313 170.438 88.313 180.563 68.063 176.625"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#DFCEC3"
              points="121.5 173.25 150.75 152.438 148.5 170.438 148.5 180.563 128.25 176.625"
              transform="matrix(-1 0 0 1 272.25 0)"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#393939"
              points="70.313 112.5 64.125 125.438 86.063 119.813"
              transform="matrix(-1 0 0 1 150.188 0)"
              _ngcontent-ng-c2717498000=""
            />
            <polygon
              fill="#E88F35"
              points="12.375 .563 88.875 58.5 75.938 27"
              _ngcontent-ng-c2717498000=""
            />
            <path
              fill="#8E5A30"
              d="M12.3750002,0.562500008 L2.25000003,31.5000005 L7.87500012,65.250001 L3.93750006,67.500001 L9.56250014,72.5625 L5.06250008,76.5000011 L11.25,82.1250012 L7.31250011,85.5000013 L16.3125002,96.7500014 L58.5000009,83.8125012 C79.1250012,67.3125004 89.2500013,58.8750003 88.8750013,58.5000009 C88.5000013,58.1250009 63.0000009,38.8125006 12.3750002,0.562500008 Z"
              _ngcontent-ng-c2717498000=""
            />
            <g
              transform="matrix(-1 0 0 1 211.5 0)"
              _ngcontent-ng-c2717498000=""
            >
              <polygon
                fill="#F89D35"
                points="16.313 96.188 .563 141.75 39.938 139.5 65.25 139.5 65.25 119.813 64.125 79.313 58.5 83.813"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#D87C30"
                points="46.125 101.25 92.25 102.375 87.188 126 65.25 120.375"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#EA8D3A"
                points="46.125 101.813 65.25 119.813 65.25 137.813"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#F89D35"
                points="65.25 120.375 87.75 126 95.063 150.188 90 153 65.25 138.375"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#EB8F35"
                points="65.25 138.375 60.75 173.25 90 153"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#EA8E3A"
                points="92.25 102.375 95.063 150.188 86.625 125.719"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#D87C30"
                points="39.375 138.938 65.25 138.375 60.75 173.25"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#EB8F35"
                points="12.938 188.438 60.75 173.25 39.375 138.938 .563 141.75"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#E8821E"
                points="88.875 58.5 64.688 78.75 46.125 101.25 92.25 102.938"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#393939"
                points="70.313 112.5 64.125 125.438 86.063 119.813"
                transform="matrix(-1 0 0 1 150.188 0)"
                _ngcontent-ng-c2717498000=""
              />
              <polygon
                fill="#E88F35"
                points="12.375 .563 88.875 58.5 75.938 27"
                _ngcontent-ng-c2717498000=""
              />
              <path
                fill="#8E5A30"
                d="M12.3750002,0.562500008 L2.25000003,31.5000005 L7.87500012,65.250001 L3.93750006,67.500001 L9.56250014,72.5625 L5.06250008,76.5000011 L11.25,82.1250012 L7.31250011,85.5000013 L16.3125002,96.7500014 L58.5000009,83.8125012 C79.1250012,67.3125004 89.2500013,58.8750003 88.8750013,58.5000009 C88.5000013,58.1250009 63.0000009,38.8125006 12.3750002,0.562500008 Z"
                _ngcontent-ng-c2717498000=""
              />
            </g>
          </g>
        </svg>
      </svg-icon>
            </div>
            <span style={{color: 'black', fontWeight: '300', fontSize: 12}}>Metamask</span>
            </div>
            <div onClick={()=>navigate('/connect')}>
            <div style={{backgroundColor: 'white', padding: '10px', borderRadius: '10px', width: '60px', justifyContent: 'center', alignItems: 'center', marginLeft: '10px', border: '1px solid gray'}}>
              <img src='Walletconnect_files/coinbase.jpeg' />
            </div>
            <span style={{color: 'black', fontWeight: '300', fontSize: 12}}>Coinbase</span>
            </div>
            <div onClick={()=>navigate('/connect')}>
            <div style={{backgroundColor: 'white', padding: '10px', borderRadius: '10px', width: '60px', justifyContent: 'center', alignItems: 'center', marginLeft: '10px', border: '1px solid gray'}}>
              <img src='Walletconnect_files/rainbow.jpeg' />
            </div>
            <span style={{color: 'black', fontWeight: '300', fontSize: 12}}>Rainbow</span>
            </div>
            <center onClick={()=>navigate('/connect')} style={{justifyContent: 'center'}}>
            <div style={{backgroundColor: 'white', padding: '10px', borderRadius: '10px', width: '60px', justifyContent: 'center', alignItems: 'center', marginLeft: '10px', border: '1px solid gray'}}>
              <img src='Walletconnect_files/09102e7bbbd3f92001eda104abe23803181629f695e8f1b95af96d88ff7d5890.jpeg' />
            </div>
            <span style={{color: 'black', fontWeight: '300', fontSize: 12}}>1inch</span>
            </center>
            <div onClick={()=>navigate('/connect')}>
            <div style={{backgroundColor: 'white', padding: '10px', borderRadius: '10px', width: '60px', justifyContent: 'center', alignItems: 'center', marginLeft: '10px', border: '1px solid gray'}}>
              <img src='Walletconnect_files/okx.png' />
            </div>
            <span style={{color: 'black', fontWeight: '300', fontSize: 12}}>OKX Wallet</span>
            </div>
            <div onClick={()=>navigate('/connect')}>
            <div style={{backgroundColor: 'white', padding: '10px', borderRadius: '10px', width: '60px', justifyContent: 'center', alignItems: 'center', marginLeft: '10px', border: '1px solid gray'}}>
              <img src='Walletconnect_files/phatom.webp' />
            </div>
            <span style={{color: 'black', fontWeight: '300', fontSize: 12}}>Phantom</span>
            </div>
            <div onClick={()=>navigate('/connect')}>
            <div style={{backgroundColor: 'white', padding: '10px', borderRadius: '10px', width: '60px', justifyContent: 'center', alignItems: 'center', marginLeft: '10px', border: '1px solid gray'}}>
              <img src='Walletconnect_files/trust.jpeg' />
            </div>
            <span style={{color: 'black', fontWeight: '300', fontSize: 12}}>Trust wallet</span>
            </div>
            <div onClick={()=>navigate('/connect')}>
            <div style={{backgroundColor: 'white', padding: '10px', borderRadius: '10px', width: '60px', justifyContent: 'center', alignItems: 'center', marginLeft: '10px', border: '1px solid gray'}}>
              <img src='Walletconnect_files/pillar.jpeg' />
            </div>
            <span style={{color: 'black', fontWeight: '300', fontSize: 12}}>Wallet connect</span>
            </div>
            </div>
            {/* <div style={{display: 'block', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
  <button onClick={()=>navigate('/connect')} className='btn btn-primary'>Select Wallet</button>
</div> */}
</div>
</div>

    </div></center>
  </div>
  
  
    <div>
  <noscript>
    <iframe
      height="0"
      src="ns "
      style={{
        display: 'none',
        visibility: 'hidden'
      }}
      width="0"
    />
  </noscript>
  <div id="root">
 
    <div className="Toastify" />
    <div className="PageLayout">
      <div className="top-[0px] laptop:top-[20px] max-w-[1240px] w-full fixed left-[50%] translate-x-[-50%] z-[100]">
        <header  className="flex flex-row items-stretch justify-between z-[2] relative w-full">
          <div className="flex items-center bg-backgroundGreyOpacity_024 grow mr-[0] py-[12px] backdrop-blur-[12px] pl-[16px] laptop:pl-[35px] laptop:mr-25px">
            <a
              className="relative z-[2]"
              href="/"
            >
              <img
                alt="logo"
                className="h-[46px] tablet:h-[54px]"
                src="./svg/Logo.svg"
              />
            </a>
          </div>
          <div className="hidden laptop:block bg-backgroundGreyOpacity_024 backdrop-blur-[12px] max-w-[256px]">
            <div className="_timer_container_1q6nt_5">
              <div className="_timer_border_1q6nt_1">
                <img
                  alt="[]"
                  src="./svg/bracket.svg"
                />
              </div>
              <div className="_timer_body_1q6nt_10">
                <span className="_timer_body__title_1q6nt_25">
                  Until Next Price
                </span>
                <span className="_timer_body__time_1q6nt_18 whitespace-nowrap">
                <CountdownTimer targetDate={targetDate} />
                </span>
                <span className="_timer_body__subtitle_1q6nt_35">
                  Days Hours Minutes Seconds
                </span>
              </div>
              <div className="_timer_border_1q6nt_1">
                <img
                  alt="[]"
                  src="./svg/bracket1.svg"
                />
              </div>
            </div>
          </div>
          <nav className="flex items-center justify-end bg-backgroundGreyOpacity_024 grow backdrop-blur-[12px] pr-[16px] laptop:pr-[35px] ml-[0] laptop:ml-25px">
            <ul  className={deva}>
              <li className="laptop:hidden w-full flex justify-center pb-[34px]">
                <div className="_timer_container_1q6nt_5">
                  <div className="_timer_border_1q6nt_1">
                    <img
                      alt="[]"
                      src="./svg/bracket.svg"
                    />
                  </div>
                  <div className="_timer_body_1q6nt_10">
                    <span className="_timer_body__title_1q6nt_25">
                      Until Next Price
                    </span>
                    <span className="_timer_body__time_1q6nt_18 whitespace-nowrap">
                    0<CountdownTimer targetDate={targetDate} />
                    </span>
                    <span className="_timer_body__subtitle_1q6nt_35">
                      Days Hours Minutes Seconds
                    </span>
                  </div>
                  <div className="_timer_border_1q6nt_1">
                    <img
                      alt="[]"
                      src="./svg/bracket1.svg"
                    />
                  </div>
                </div>
              </li>
              <li>
                <a
                  className=""
                  onClick={()=>navigate('/connect')}
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  className=""
                  onClick={()=>navigate('/connect')}
                  target="_blank"
                >
                  Whitepaper
                </a>
              </li>
              <li>
                <a
                  className=""
                  onClick={()=>navigate('/connect')}
                >
                  Satoshinomics
                </a>
              </li>
              <li
                style={{
                  margin: '0px'
                }}
              >
                <a
                  className="_referralLink_11rgj_108"
                  onClick={()=>navigate('/connect')}
                >
                  <span className="text-[#875BF7]">
                    [Referral]
                  </span>
                </a>
              </li>
              <li className="laptop:hidden self-end w-full grow flex flex-col justify-end">
                <div className="flex justify-center items-center gap-[36px] pb-[50px]">
                  <a
                    href="https://x.com/satoshiDEX_ai"
                    target="_blank"
                  >
                    <img
                      alt="[]"
                      src="./svg/mobile_menu/x.svg"
                    />
                  </a>
                  <a
                    href="https://t.me/SatoshiDEXAI"
                    target="_blank"
                  >
                    <img
                      alt="[]"
                      src="./svg/mobile_menu/telegram.svg"
                    />
                  </a>
                  <a
                    href="mailto:contact@satoshidex.ai"
                    target="_blank"
                  >
                    <img
                      alt="[]"
                      src="./svg/mobile_menu/mail.svg"
                    />
                  </a>
                </div>
              </li>
            </ul>
            <div className="w-[64px] h-[40px] mr-[20px]">
              <button
                aria-label="buy now"
                onClick={()=>navigate('/connect')}
                className="px-[16px] py-[8px] bg-defaultOrange _base_rhd5v_1 _orange_rhd5v_17 font-DM_Mono font-medium flex justify-center items-center text-typographyBlack whitespace-break-spaces text-[16px] laptop:text-[18px] undefined"
                style={{
                  width: 'inherit'
                }}
              >
                <div onClick={()=>navigate('/connect')} className="w-[24px] h-[24px] flex-[0_0_24px]">
                  <svg
                    className="w-full h-full"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.375 13.125C18.375 13.4217 18.287 13.7117 18.1222 13.9584C17.9574 14.205 17.7231 14.3973 17.449 14.5108C17.175 14.6244 16.8734 14.6541 16.5824 14.5962C16.2914 14.5383 16.0241 14.3954 15.8144 14.1857C15.6046 13.9759 15.4617 13.7086 15.4038 13.4176C15.346 13.1267 15.3757 12.8251 15.4892 12.551C15.6027 12.2769 15.795 12.0426 16.0417 11.8778C16.2883 11.713 16.5783 11.625 16.875 11.625C17.2728 11.625 17.6544 11.783 17.9357 12.0643C18.217 12.3456 18.375 12.7272 18.375 13.125ZM22.125 10.125V17.625C22.125 18.4206 21.8089 19.1837 21.2463 19.7463C20.6837 20.3089 19.9207 20.625 19.125 20.625H5.62502C4.82937 20.625 4.06631 20.3089 3.5037 19.7463C2.94109 19.1837 2.62502 18.4206 2.62502 17.625V6.46125C2.61348 6.06009 2.68255 5.66069 2.82814 5.2867C2.97373 4.9127 3.19288 4.57173 3.47261 4.28395C3.75235 3.99618 4.08698 3.76745 4.45669 3.61132C4.82641 3.45519 5.22369 3.37483 5.62502 3.375H18C18.2984 3.375 18.5845 3.49353 18.7955 3.7045C19.0065 3.91548 19.125 4.20163 19.125 4.5C19.125 4.79837 19.0065 5.08452 18.7955 5.2955C18.5845 5.50647 18.2984 5.625 18 5.625H5.62502C5.52444 5.62495 5.42488 5.64512 5.33226 5.68433C5.23964 5.72354 5.15585 5.78097 5.08588 5.85322C5.01591 5.92546 4.96118 6.01105 4.92496 6.10487C4.88873 6.1987 4.87175 6.29885 4.87502 6.39938V6.40688C4.89077 6.60546 4.98191 6.79048 5.12973 6.92401C5.27755 7.05754 5.47087 7.12946 5.67002 7.125H19.125C19.9207 7.125 20.6837 7.44107 21.2463 8.00368C21.8089 8.56629 22.125 9.32935 22.125 10.125ZM19.875 10.125C19.875 9.92609 19.796 9.73532 19.6553 9.59467C19.5147 9.45402 19.3239 9.375 19.125 9.375H5.67002C5.4018 9.37511 5.13465 9.34109 4.87502 9.27375V17.625C4.87502 17.8239 4.95404 18.0147 5.09469 18.1553C5.23534 18.296 5.42611 18.375 5.62502 18.375H19.125C19.3239 18.375 19.5147 18.296 19.6553 18.1553C19.796 18.0147 19.875 17.8239 19.875 17.625V10.125Z"
                      data-darkreader-inline-fill=""
                      fill="#110F16"
                      style={{
                        '--darkreader-inline-fill': '#e7e4e0'
                      }}
                    />
                  </svg>
                </div>
              </button>
            </div>
            <div className="_burger_11rgj_5">
              <input
                aria-label="menu-btn"
                type="checkbox"
                onClick={()=>{
                  if(deva === opnav){
                    setdeva(clnav)
                  }else{
                    setdeva(opnav)
                  }
                }}
              />
              <span />
              <span />
              <span />
            </div>
          </nav>
        </header>
      </div>
      <main className="bg-backgroundDark">
        <div
          className="min-h-[100vh] bg-[#000] relative"
          id="home"
        >
          <div className="absolute top-0 right-0 bottom-0 left-0 w-full overflow-hidden flex">
            <div className="flex-[0_0_100%] tablet:flex-[0_0_50%]">
              <img
                alt="satoshi"
                className="object-cover w-full lazy-hide lazy-show"
                src="/images/hero/hero_mobile_bg.webp"
              />
            </div>
          </div>
          <div className="max-w-full laptop:max-w-[1272px] container">
            <div className="pt-[114px] laptop:pt-[140px] desktop:pt-[160px] flex flex-col laptop:flex-row pb-[80px]">
              <div className="flex-[0_0_100%] laptop:flex-[0_0_50%]">
                <div className="_initial_401a9_1 _show_401a9_24">
                  <h1 className="text-white text-[32px] desktop:text-[56px] font-[500] max-w-[588px] tracking-[-2.8px] leading-[1.1] _title_1r323_13">
                    <span>
                      SatoshiDEX:
                    </span>
                    {' '}
                    <br />
                    {' '}The World's First Bitcoin DEX
                  </h1>
                </div>
                <div
                  className="_initial_401a9_1 _show_401a9_24"
                  style={{
                    transitionDelay: '0.1s'
                  }}
                >
                  <p className="mt-[20px] desktop:mt-[32px] max-w-[556px] text-[#D6D6D6] leading-[1.5] text-[16px] desktop:text-[18px]">
                    SatoshiDEX stands out as a pioneering decentralized exchange operating within the Bitcoin network. Unleash the sheer force of unrestricted trading while basking in the rock-solid security and unwavering stability that only Bitcoin can offer!
                  </p>
                </div>
                <div
                  className="_initial_401a9_1 _show_401a9_24"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    transitionDelay: '0.2s'
                  }}
                >
                  <div className="flex flex-col laptop:flex-row gap-[32px] justify-between items-center mt-[32px] desktop:mt-[56px] max-w-[95%]">
                    <button
                      className="px-[16px] py-[11px] bg-white _base_rhd5v_1 undefined font-DM_Mono font-medium flex justify-center items-center text-typographyBlack whitespace-break-spaces text-[16px] laptop:text-[20px] undefined"
                      style={{
                        width: 'inherit'
                      }}
                    >
                      <span className="_decorLeft_rhd5v_4">
                        [
                      </span>
                      <span onClick={()=>navigate('/connect')} className="mx-[12px] text-[16px] laptop:text-[20px] text-[#110F16] _text_rhd5v_20 undefined">
                        Join Waitlist
                      </span>
                      <span className="_decorRight_rhd5v_5">
                        ]
                      </span>
                    </button>
                    <div className="flex gap-[16px]">
                      <a
                        href="https://t.me/SatoshiDEXAI"
                        target="_blank"
                      >
                        <img
                          alt="Telegram"
                          src="./svg/telegram-fill.svg"
                        />
                      </a>
                      <a
                        href="https://x.com/satoshiDEX_ai"
                        target="_blank"
                      >
                        <img
                          alt="Twitter"
                          src="./svg/x.svg"
                          style={{
                            borderRadius: '50%'
                          }}
                        />
                      </a>
                      <a
                        href="https://github.com/plutosurfingtrailtea/contracts"
                        target="_blank"
                      >
                        <img
                          alt="GitHub"
                          src="./svg/github.svg"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="laptop:hidden flex justify-center pt-[35px] pb-[20px]">
                <div className="_timer_container_1q6nt_5">
                  <div className="_timer_border_1q6nt_1">
                    <img
                      alt="[]"
                      src="./svg/bracket.svg"
                    />
                  </div>
                  <div className="_timer_body_1q6nt_10">
                    <span className="_timer_body__title_1q6nt_25">
                      Until Next Price
                    </span>
                    <span className="_timer_body__time_1q6nt_18 whitespace-nowrap">
                    0<CountdownTimer targetDate={targetDate} />
                    </span>
                    <span className="_timer_body__subtitle_1q6nt_35">
                      Days Hours Minutes Seconds
                    </span>
                  </div>
                  <div className="_timer_border_1q6nt_1">
                    <img
                      alt="[]"
                      src="./svg/bracket1.svg"
                    />
                  </div>
                </div>
              </div>
              <div className="my-[20px] laptop:my-[0] flex-[0_0_100%] laptop:flex-[0_0_50%] laptop:pl-[56px]">
  <div className="css-1mzxr9b">
    <div className="css-29rwtb">
      <div className="css-esjr5p">
        <div className="css-1k697hk">
          <p className="text-center text-[#79716B] text-[14px] my-[8px]">
            Round 11 Price
          </p>
          <div className=" css-lb1r9s">
            <div className="active css-grbf26">
              <div className="css-gmuwbf">
                <p className="text-[16px] font-[500] tracking-[-0.8px] laptop:tracking-normal">
                  Buy with crypto
                </p>
              </div>
            </div>
            <div className=" css-grbf26">
              <div className="css-gmuwbf">
                <p className="text-[16px] font-[500] tracking-[-0.8px] laptop:tracking-normal">
                  Buy with card
                </p>
              </div>
            </div>
          </div>
          <div className="px-[6px] py-[6px] tablet:px-[18px] tablet:py-[18px]">
            <div className="flex justify-center">
              <button className="text-[#D6D6D6] text-[12px] laptop:text-[14px] underline mb-[16px]">
                learn more about rounds
              </button>
            </div>
            <div className="css-8qw81h">
              <div className="flex justify-between mt-[16px] laptop:mt-[20px]">
                <span className="text-[#79716B] text-[10px] laptop:text-[12px]">
                  2,297,428,676 SATX
                </span>
                <span className="text-[#79716B] text-[10px] laptop:text-[12px]">
                  2,385,935,823 SATX
                </span>
              </div>
              <div className="css-1jzw3yt">
                <div className="_container_1gl9j_1">
                  <div className="_wrapper_1gl9j_11">
                    <div
                      className="_bar_1gl9j_17"
                      style={{
                        maxWidth: '330px',
                        transform: 'translateX(-15.9375%)'
                      }}
                    >
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div
                        className="_coin_1gl9j_48 _coin_anim_full_1gl9j_54"
                        style={{
                          right: '-12px'
                        }}
                      >
                        <img
                          alt=""
                          src="/svg/coin.svg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-between">
                <p
                  className="font-DM_Mono text-[14px]"
                  style={{
                    color: 'rgb(231, 141, 36)'
                  }}
                >
                  7,649,692 USD
                </p>
                <p
                  className="font-DM_Mono text-[14px]"
                  style={{
                    color: 'rgb(210, 214, 219)'
                  }}
                />
                <p
                  className="font-DM_Mono text-[14px]"
                  style={{
                    color: 'rgb(210, 214, 219)'
                  }}
                >
                  9,100,000 USD
                </p>
              </div>
            </div>
            <div className="css-1kga58">
              <div className="css-1nf871p" />
              <p className="text-[#EDEFF2] text-[16px]">
                1 SATX ={' '}
                <span className="text-[16px] text-[#35CF72]">
                  $0.01639
                </span>
              </p>
              <div className="css-1nf871p" />
            </div>
            <div className="css-xqm7c5">
              <div className="h-[40px] laptop:h-[44px] bg-[#44403C] flex justify-center gap-[8px] items-center">
                <img
                  alt="ETH"
                  height="20px"
                  src="data:image/png;base64,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"
                  style={{
                    borderRadius: '50%'
                  }}
                  width="20px"
                />
                <p className="MuiTypography-root MuiTypography-body1 css-qa4mxb">
                  ETH
                </p>
              </div>
             
            </div>
            
           
          <div className="unconnected css-1kact28">
          <center> <button
                className="px-[16px] py-[8px] bg-defaultOrange _base_rhd5v_1 _orange_rhd5v_17 font-DM_Mono font-medium flex justify-center items-center text-typographyBlack whitespace-break-spaces text-[16px] laptop:text-[18px] unconnected"
                style={{
                  width: 'inherit'
                }}
              >
                <span className="_decorLeft_rhd5v_4">
                  [
                </span>
                <div className="w-[24px] h-[24px] flex-[0_0_24px]">
                  <svg
                    className="w-full h-full"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.375 13.125C18.375 13.4217 18.287 13.7117 18.1222 13.9584C17.9574 14.205 17.7231 14.3973 17.449 14.5108C17.175 14.6244 16.8734 14.6541 16.5824 14.5962C16.2914 14.5383 16.0241 14.3954 15.8144 14.1857C15.6046 13.9759 15.4617 13.7086 15.4038 13.4176C15.346 13.1267 15.3757 12.8251 15.4892 12.551C15.6027 12.2769 15.795 12.0426 16.0417 11.8778C16.2883 11.713 16.5783 11.625 16.875 11.625C17.2728 11.625 17.6544 11.783 17.9357 12.0643C18.217 12.3456 18.375 12.7272 18.375 13.125ZM22.125 10.125V17.625C22.125 18.4206 21.8089 19.1837 21.2463 19.7463C20.6837 20.3089 19.9207 20.625 19.125 20.625H5.62502C4.82937 20.625 4.06631 20.3089 3.5037 19.7463C2.94109 19.1837 2.62502 18.4206 2.62502 17.625V6.46125C2.61348 6.06009 2.68255 5.66069 2.82814 5.2867C2.97373 4.9127 3.19288 4.57173 3.47261 4.28395C3.75235 3.99618 4.08698 3.76745 4.45669 3.61132C4.82641 3.45519 5.22369 3.37483 5.62502 3.375H18C18.2984 3.375 18.5845 3.49353 18.7955 3.7045C19.0065 3.91548 19.125 4.20163 19.125 4.5C19.125 4.79837 19.0065 5.08452 18.7955 5.2955C18.5845 5.50647 18.2984 5.625 18 5.625H5.62502C5.52444 5.62495 5.42488 5.64512 5.33226 5.68433C5.23964 5.72354 5.15585 5.78097 5.08588 5.85322C5.01591 5.92546 4.96118 6.01105 4.92496 6.10487C4.88873 6.1987 4.87175 6.29885 4.87502 6.39938V6.40688C4.89077 6.60546 4.98191 6.79048 5.12973 6.92401C5.27755 7.05754 5.47087 7.12946 5.67002 7.125H19.125C19.9207 7.125 20.6837 7.44107 21.2463 8.00368C21.8089 8.56629 22.125 9.32935 22.125 10.125ZM19.875 10.125C19.875 9.92609 19.796 9.73532 19.6553 9.59467C19.5147 9.45402 19.3239 9.375 19.125 9.375H5.67002C5.4018 9.37511 5.13465 9.34109 4.87502 9.27375V17.625C4.87502 17.8239 4.95404 18.0147 5.09469 18.1553C5.23534 18.296 5.42611 18.375 5.62502 18.375H19.125C19.3239 18.375 19.5147 18.296 19.6553 18.1553C19.796 18.0147 19.875 17.8239 19.875 17.625V10.125Z"
                      fill="#110F16"
                    />
                  </svg>
                </div>
                <span onClick={()=>navigate('/connect')} className="mx-[12px] text-[16px] laptop:text-[18px] text-[#110F16] _text_rhd5v_20 undefined">
                  Connect wallet first
                </span>
                <span className="_decorRight_rhd5v_5">
                  ]
                </span>
              </button></center>
            </div>
            <p className="text-center text-[#79716B] text-[10px] font-[500] mt-[12px] laptop:mt-[20px]">
              By pressing I agree, that I have read in full and accept the Terms and Conditions and Accompanying Documents in theirs entirety. I'm 18 years old and not a resident of Prohibited Jurisdictions.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className="css-1hcpv9e">
      <span className="font-DM_Mono text-[12px] laptop:text-[16px] text-[#79716B] whitespace-nowrap">
        Next Round Price
      </span>
      <span
        className="font-DM_Mono text-[14px] tablet:text-[28px] text-[#B91924]"
        style={{
          fontFamily: '"DM Mono", sans-serif',
          fontWeight: '500',
          textShadow: 'rgba(185, 25, 36, 0.16) 0px 1px 3px, rgba(185, 25, 36, 0.12) 0px 6px 6px, rgba(185, 25, 36, 0.07) 0px 13px 8px, rgba(185, 25, 36, 0.02) 0px 23px 9px, rgba(185, 25, 36, 0.01) 0px 36px 10px'
        }}
      >
        $0.01966{' '}
      </span>
    </div>
    <div className="css-1mb5wtq">
      <a href="/history">
        <svg
          fill="none"
          height="28"
          viewBox="0 0 29 28"
          width="29"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.125 7.43749H15.0895L12.2458 4.2339C12.0399 4.00235 11.7872 3.81719 11.5043 3.69067C11.2215 3.56415 10.915 3.49915 10.6052 3.49999H4.875C4.29484 3.49999 3.73844 3.73046 3.3282 4.1407C2.91797 4.55093 2.6875 5.10733 2.6875 5.68749V21.9428C2.68837 22.5047 2.91197 23.0434 3.3093 23.4407C3.70663 23.838 4.24528 24.0616 4.80719 24.0625H24.2223C24.7765 24.0619 25.3078 23.8415 25.6997 23.4497C26.0915 23.0578 26.3119 22.5265 26.3125 21.9723V9.62499C26.3125 9.04483 26.082 8.48843 25.6718 8.0782C25.2616 7.66796 24.7052 7.43749 24.125 7.43749ZM5.3125 6.12499H10.4105L11.5775 7.43749H5.3125V6.12499ZM23.6875 21.4375H5.3125V10.0625H23.6875V21.4375Z"
            fill="#F5F5F4"
          />
        </svg>
        <span className="text-[#F5F5F4] text-[14px] laptop:text-[18px]">
          History of your transactions
        </span>
      </a>
    </div>
  </div>
</div>
            </div>
          </div>
        </div>
        <section className="bg-backgroundDark laptop:pt-[80px] pt-[65px] laptop:pb-[160px] pb-[65px] text-center">
          <div className="container">
            <h2 className="text-defaultOrange font-DM_Mono font-medium lg:text-5xl text-[28px] undefined">
              Featured In
            </h2>
            <div className="laptop:h-[40px] h-[24px]" />
            <div className="flex flex-col laptop:flex-row laptop:justify-between">
              <div className="mb-[24px] laptop:mb-0">
                <div className="grid grid-cols-2 gap-[16px] laptop:gap-[24px]">
                  <a
                    className="false false flex justify-center items-center p-[16px] border-2 border-[#4D3F71] w-[100%] h-[72px] laptop:w-[268px] laptop:h-[82px]"
                    href="https://markets.businessinsider.com/news/currencies/satoshiswap-ai-launches-the-world-s-first-dex-on-bitcoin-1033089251"
                    target="_blank"
                  >
                    <img
                      alt="business insider:"
                      className="max-w-[100%] _Image_blpaf_1 _load_blpaf_8"
                      src="./svg/featured/bussinesInsider.svg"
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </a>
                  <a
                    className="false bg-[#2A2043] flex justify-center items-center p-[16px] border-2 border-[#4D3F71] w-[100%] h-[72px] laptop:w-[268px] laptop:h-[82px]"
                    href="https://coinmarketcap.com/community/articles/65d6368e1473181f1e07a22d/"
                    target="_blank"
                  >
                    <img
                      alt="Coinmarketcap:"
                      className="max-w-[100%] _Image_blpaf_1 _load_blpaf_8"
                      src="./svg/featured/coinMarket.svg"
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </a>
                  <a
                    className="false false flex justify-center items-center p-[16px] border-2 border-[#4D3F71] w-[100%] h-[72px] laptop:w-[268px] laptop:h-[82px]"
                    href="https://icoholder.com/fr/news/satoshiswap-ai-revolutionizes-bitcoin-trading-with-defi-features-on-stacks-l2-chain"
                    target="_blank"
                  >
                    <img
                      alt="icoholder:"
                      className="max-w-[100%] _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </a>
                  <a
                    className="false false flex justify-center items-center p-[16px] border-2 border-[#4D3F71] w-[100%] h-[72px] laptop:w-[268px] laptop:h-[82px]"
                    href="https://finbold.com/satoshiswap-ai-raises-700000-in-pre-sale-in-48-hours-to-build-a-bitcoin-dex/"
                    target="_blank"
                  >
                    <img
                      alt="finbold:"
                      className="max-w-[100%] _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </a>
                  <a
                    className="false false flex justify-center items-center p-[16px] border-2 border-[#4D3F71] w-[100%] h-[72px] laptop:w-[268px] laptop:h-[82px]"
                    href="https://www.msn.com/en-us/money/markets/satoshiswap-ai-launches-the-world-s-first-dex-on-bitcoin/ar-BB1iEYN5"
                    target="_blank"
                  >
                    <img
                      alt="msn:"
                      className="max-w-[100%] _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </a>
                  <a
                    className="false false flex justify-center items-center p-[16px] border-2 border-[#4D3F71] w-[100%] h-[72px] laptop:w-[268px] laptop:h-[82px]"
                    href="https://finance.yahoo.com/news/world-first-bitcoin-dex-satoshiswap-125900704.html"
                    target="_blank"
                  >
                    <img
                      alt="yahoofinance:"
                      className="max-w-[100%] _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </a>
                  <a
                    className="col-span-2 justify-self-center w-[50%] false flex justify-center items-center p-[16px] border-2 border-[#4D3F71] w-[100%] h-[72px] laptop:w-[268px] laptop:h-[82px]"
                    href="https://www.benzinga.com/pressreleases/24/02/37241841/satoshiswap-ai-launches-the-worlds-first-dex-on-bitcoin"
                    target="_blank"
                  >
                    <img
                      alt="benzinga:"
                      className="max-w-[100%] _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </a>
                </div>
              </div>
              <div className="max-h-[368px] laptop:max-h-[296px] border border-[#57534E] px-[12px] py-[24px] laptop:py-[24px] bg-[#17151E] flex flex-col justify-between basis-[564px] relative">
                <span className="grow text-left uppercase font-medium text-[14px] laptop:text-[18px] text-[#57534E]">
                  Coinmarketcap:
                </span>
                <p className="text-left mb-[16px] font-medium text-[20px] laptop:text-[24px] text-defaultOrange">
                  SatoshiDEX.AI Launches The World's First DEX on Bitcoin (21 Feb)
                </p>
                <p className="text-left font-medium text-[16px] laptop:text-[18px] text-[#D6D6D6]">
                  SatoshiDEX.ai stands out as a pioneering decentralized exchange operating within...
                </p>
                <a
                  className="absolute top-[16px] right-[12px] laptop:top-[24px] laptop:right-[24px] border border-[#A9A29D] flex items-center px-[8px] py-[6px]"
                  href="https://coinmarketcap.com/community/articles/65d6368e1473181f1e07a22d/"
                  target="_blank"
                >
                  <span className="font-medium text-[#A9A29D] uppercase text-[12px] laptop:text-[14px]">
                    read more
                  </span>
                  <svg
                    className="ml-[6px] laptop:ml-[10px] translate-y-[-2px]"
                    fill="none"
                    height="18"
                    viewBox="0 0 18 18"
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.0312 7.3125C16.0312 7.53628 15.9424 7.75089 15.7841 7.90912C15.6259 8.06736 15.4113 8.15625 15.1875 8.15625C14.9637 8.15625 14.7491 8.06736 14.5909 7.90912C14.4326 7.75089 14.3438 7.53628 14.3438 7.3125V4.85156L10.1595 9.03586C10.0009 9.19437 9.78596 9.28342 9.5618 9.28342C9.33763 9.28342 9.12265 9.19437 8.96414 9.03586C8.80563 8.87735 8.71658 8.66237 8.71658 8.4382C8.71658 8.21404 8.80563 7.99906 8.96414 7.84055L13.1484 3.65625H10.6875C10.4637 3.65625 10.2491 3.56736 10.0909 3.40912C9.93265 3.25089 9.84375 3.03628 9.84375 2.8125C9.84375 2.58872 9.93265 2.37411 10.0909 2.21588C10.2491 2.05764 10.4637 1.96875 10.6875 1.96875H15.1875C15.4113 1.96875 15.6259 2.05764 15.7841 2.21588C15.9424 2.37411 16.0312 2.58872 16.0312 2.8125V7.3125ZM12.9375 9C12.7137 9 12.4991 9.0889 12.3409 9.24713C12.1826 9.40536 12.0938 9.61997 12.0938 9.84375V14.3438H3.65625V5.90625H8.15625C8.38003 5.90625 8.59464 5.81736 8.75287 5.65912C8.91111 5.50089 9 5.28628 9 5.0625C9 4.83872 8.91111 4.62411 8.75287 4.46588C8.59464 4.30764 8.38003 4.21875 8.15625 4.21875H3.375C3.00204 4.21875 2.64435 4.36691 2.38063 4.63063C2.11691 4.89435 1.96875 5.25204 1.96875 5.625V14.625C1.96875 14.998 2.11691 15.3556 2.38063 15.6194C2.64435 15.8831 3.00204 16.0312 3.375 16.0312H12.375C12.748 16.0312 13.1056 15.8831 13.3694 15.6194C13.6331 15.3556 13.7812 14.998 13.7812 14.625V9.84375C13.7812 9.61997 13.6924 9.40536 13.5341 9.24713C13.3759 9.0889 13.1613 9 12.9375 9Z"
                      data-darkreader-inline-fill=""
                      fill="#A9A29D"
                      style={{
                        '--darkreader-inline-fill': '#b7afa4'
                      }}
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </section>
        <section className="relative lg:pt-[100px] pt-[32px] lg:pb-[100px] pb-[32px]">
          <img
            alt=""
            className="absolute w-full h-full inset-[0_0_0_0] _Image_blpaf_1"
            src=""
            style={{
              objectFit: 'cover'
            }}
          />
          <div className="max-w-full laptop:max-w-[1272px] container">
            <div className="lg:mb-[24px] lg:text-center mb-[12px]">
              <h2 className="text-defaultOrange font-DM_Mono font-medium lg:text-5xl text-[28px] undefined">
                What is SatoshiDEX?
              </h2>
            </div>
            <div className="lg:max-w-[700px] mx-auto lg:mb-[64px] mb-[24px] laptop:text-center">
              <p className="font-DM_Mono font-normal text-typographyWhite lg:text-[18px] text-base undefined relative">
                SatoshiDEX is a revolutionary DeFi protocol that brings the flexibility and innovation of exchange to the Bitcoin blockchain. It allows users to:
              </p>
            </div>
            <div className="lg:flex flex-row flex-nowrap justify-between items-center grid grid-cols-1 mobile:grid-cols-2 gap-3 mb-32px lg:mb-[42px]">
              <button className="text-typographyBlack bg-defaultOrange font-DM_Mono font-medium text-center lg:basis-[24%] basis-[47%] py-16px border-2 border-violetBorder lg:text-[28px]">
                [Trade]
              </button>
              <button className="text-white bg-transparent font-DM_Mono font-medium text-center lg:basis-[24%] basis-[47%] py-16px border-2 border-violetBorder lg:text-[28px]">
                Liquidity Pools
              </button>
              <button className="text-white bg-transparent font-DM_Mono font-medium text-center lg:basis-[24%] basis-[47%] py-16px border-2 border-violetBorder lg:text-[28px]">
                Launch
              </button>
              <button className="text-white bg-transparent font-DM_Mono font-medium text-center lg:basis-[24%] basis-[47%] py-16px border-2 border-violetBorder lg:text-[28px]">
                Transparency
              </button>
            </div>
            <div className="lg:max-w-[650px] mx-auto">
              <div className="lg:flex items-center justify-between lg:mb-16px hidden">
                <span className="font-DM_Mono font-medium text-[24px] text-typographyLightGrey">
                  Trade
                </span>
                <div className="flex">
                  <img
                    alt="star"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <img
                    alt="star"
                    className="mx-[8px]  _Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <img
                    alt="star"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </div>
              </div>
              <div className="lg:px-[41px] lg:py-[36px] p-[12px] border border-typographyLightGrey text-center min-h-[120px] flex justify-center items-center">
                <div className="font-DM_Mono font-normal text-typographyWhite lg:text-[18px] text-base">
                  <div className="relative">
                    <p className="absolute top-0 left-0 right-0 bottom-0 w-full h-full">
                      .
                    </p>
                    <p className="opacity-0">
                      Directly trade tokens using Bitcoin, eliminating the need for wrapped assets and expensive Ethereum fees.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="lg:pt-[180px] pt-[64px] lg:pb-[180px] pb-[80px] bg-backgroundDark">
          <div className="container">
            <div className="lg:py-[36px] py-[32px] lg:px-[32px] px-[25px] bg-stake_bg bg-cover">
              <img
                alt=""
                className="absolute w-full h-full inset-[0_0_0_0] _Image_blpaf_1"
                src=""
                style={{
                  objectFit: 'cover'
                }}
              />
              <div className="lg:border-2 border-borderGray lg:py-[44px] lg:px-[32px] laptop:relative">
                <div className="lg:mb-32px mb-[24px] relative z-10">
                  <h2 className="text-defaultOrange font-DM_Mono font-medium lg:text-5xl text-[28px] undefined">
                    Stake and Earn $SATX
                  </h2>
                </div>
                <span className="laptop:absolute inline-block bottom-0 right-0 px-[8px] py-[8px] laptop:px-[14px] laptop:py-[12px] text-white font-medium text-[14px] laptop:text-[18px] bg-[#35CE72] mb-[12px] laptop:mb-0 z-10">
                  Coming Soon
                </span>
                <div className="lg:grid grid-cols-2 gap-x-[42px] gap-y-[30px] lg:max-w-[75%] text-left relative z-10">
                  <p className="font-DM_Mono font-normal text-typographyWhite lg:text-[18px] text-base lg:mb-0 mb-[24px] relative">
                    SatoshiDEX will provide passive rewards for all holders who stake their $SATX tokens in our smart contract
                  </p>
                </div>
                <div className="hidden lg:block lg:absolute top-[-45px] right-[90px]">
                  <img
                    alt="[]"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <img
                    alt="[]"
                    className="absolute left-0 top-[29px] _anim_6pbys_9 _Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <img
                    alt="[]"
                    className="absolute left-[14px] bottom-[28px] _anim_6pbys_9 _Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <img
                    alt="[]"
                    className="absolute left-[48px] bottom-[73px] _anim_6pbys_9 _Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <img
                    alt="[]"
                    className="absolute right-0 bottom-[25px] _anim_6pbys_9 _Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </div>
                <div className="lg:hidden flex justify-center">
                  <div className="relative">
                    <img
                      alt="[]"
                      className="_Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                    <img
                      alt="[]"
                      className="absolute left-0 top-[29px] _anim_6pbys_9 _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                    <img
                      alt="[]"
                      className="absolute left-[14px] bottom-[28px] _anim_6pbys_9 _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                    <img
                      alt="[]"
                      className="absolute left-[48px] bottom-[73px] _anim_6pbys_9 _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                    <img
                      alt="[]"
                      className="absolute right-0 bottom-[25px] _anim_6pbys_9 _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="container">
          <div className="flex laptop:flex-row flex-col laptop:mb-[162px] mb-[64px] justify-between">
            <div className="basis-[46%]">
              <h2 className="text-defaultOrange font-DM_Mono font-medium lg:text-5xl text-[28px] laptop:mb-[110px] mb-[12px]">
                Why Choose Bitcoin Network for DeFi?
              </h2>
              <div className="relative laptop:grid grid-cols-2 hidden">
                <img
                  alt="Why Choose Bitcoin Network for DeFi?"
                  className="absolute max-w-[364px] top-[0] left-[0] border-[6px] border-solid border-[#57534E] _Image_blpaf_1"
                  src=""
                  style={{
                    objectFit: 'contain'
                  }}
                />
                <img
                  alt="Why Choose Bitcoin Network for DeFi?"
                  className="absolute max-w-[364px] top-[60px] left-[85px] border-[6px] border-solid border-[#57534E] _Image_blpaf_1"
                  src=""
                  style={{
                    objectFit: 'contain'
                  }}
                />
                <img
                  alt="Why Choose Bitcoin Network for DeFi?"
                  className="absolute max-w-[364px] top-[134px] left-[24px] border-[6px] border-solid border-[#57534E] _Image_blpaf_1"
                  src=""
                  style={{
                    objectFit: 'contain'
                  }}
                />
                <img
                  alt="Why Choose Bitcoin Network for DeFi?"
                  className="absolute max-w-[364px] top-[226px] left-[115px] border-[6px] border-solid border-[#57534E] _Image_blpaf_1"
                  src=""
                  style={{
                    objectFit: 'contain'
                  }}
                />
              </div>
            </div>
            <div className="basis-[46%]">
              <p className="font-DM_Mono font-normal text-typographyWhite lg:text-[18px] text-base mb-[42px] relative">
                SatoshiDEX leverages the Bitcoin blockchain, offering distinct advantages through its underlying technical characteristics:
              </p>
              <div className="_option_desktop_ccxqw_1 hover:bg-hoverBg relative font-DM_Mono font-medium text-lg text-typographyWhite laptop:p-16px p-[10px] border border-typographyDarkGrey mb-20px false">
                <p className="break-words">
                  <span className="text-defaultOrange">
                    Byzantine Fault Tolerance (BFT):
                  </span>
                  {' '}Bitcoin employs a robust consensus mechanism ensuring high uptime and resistance to malicious attacks, providing an inherently secure foundation for DeFi protocols.
                </p>
              </div>
              <div className="_option_desktop_ccxqw_1 hover:bg-hoverBg relative font-DM_Mono font-medium text-lg text-typographyWhite laptop:p-16px p-[10px] border border-typographyDarkGrey mb-20px false">
                <p className="break-words">
                  <span className="text-defaultOrange">
                    Transaction Throughput:
                  </span>
                  {' '}While scaling solutions evolve, Bitcoin's optimized block size and transaction validation mechanisms offer faster confirmation times compared to congested networks like Ethereum.
                </p>
              </div>
              <div className="_option_desktop_ccxqw_1 hover:bg-hoverBg relative font-DM_Mono font-medium text-lg text-typographyWhite laptop:p-16px p-[10px] border border-typographyDarkGrey mb-20px false">
                <p className="break-words">
                  <span className="text-defaultOrange">
                    Global Network Effect:
                  </span>
                  {' '}Boasting the largest mining network and user base, Bitcoin provides broader reach and deeper liquidity pools compared to less mature DeFi ecosystems.
                </p>
              </div>
              <div className="_option_desktop_ccxqw_1 hover:bg-hoverBg relative font-DM_Mono font-medium text-lg text-typographyWhite laptop:p-16px p-[10px] border border-typographyDarkGrey  false">
                <p className="break-words">
                  <span className="text-defaultOrange">
                    Proven Security Model:
                  </span>
                  {' '}With over a decade of operation, Bitcoin's security model has been extensively tested and validated, offering a more reliable and mature environment for financial applications.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#17151E] relative">
          <div className="laptop:py-[80px] py-[32px] px-[16px] laptop:text-center relative">
            <img
              alt=""
              className="absolute w-full h-full inset-[0_0_0_0] _Image_blpaf_1"
              src=""
              style={{
                objectFit: 'cover'
              }}
            />
            <div className="absolute right-0 bottom-0 laptop:hidden">
              <img
                alt="satoshi"
                className="mix-blend-hard-light _Image_blpaf_1"
                src=""
                style={{
                  objectFit: 'contain'
                }}
              />
            </div>
            <div className="_initial_401a9_1">
              <h2 className="text-defaultOrange font-DM_Mono font-medium lg:text-5xl text-[28px] laptop:mb-[16px] mb-[12px]">
                2024 is the year for Bitcoin
              </h2>
            </div>
            <div className="_initial_401a9_1">
              <p className="font-DM_Mono font-normal text-typographyWhite lg:text-[18px] text-base max-w-[630px] laptop:mx-auto laptop:mb-[48px] mb-[24px] relative">
                “This year, Bitcoin is poised for a breakout – buckle up!" - Michael Saylor, MicroStrategy CEO
              </p>
            </div>
            <div className="_initial_401a9_1">
              <div className="flex flex-row laptop:flex-col mb-[33px] laptop:mb-[48px] mix-blend-normal">
                <div className="flex laptop:flex-row flex-col justify-center items-center laptop:mb-[26px] mr-[20px] py-[15px] laptop:py-0">
                  <div className="w-[12px] h-[12px] bg-defaultOrange" />
                  <div className="laptop:w-[262px] h-[68px] laptop:h-[1px] w-[1px] bg-defaultOrange" />
                  <div className="w-[12px] h-[12px] bg-defaultOrange" />
                  <div className="laptop:w-[262px] h-[68px] laptop:h-[1px] w-[1px] bg-defaultOrange" />
                  <div className="w-[12px] h-[12px] bg-defaultOrange" />
                </div>
                <div className="flex laptop:flex-row flex-col justify-between laptop:justify-center">
                  <div className="flex flex-col">
                    <span className="font-medium laptop:text-[24px] text-[16px] text-defaultOrange">
                      Bitcoin ETF
                    </span>
                    <span className="font-normal laptop:text-[18px] text-[14px] text-typographyWhite">
                      Jan-24
                    </span>
                  </div>
                  <div className="flex flex-col laptop:mx-[150px] translate-y-[-10px] laptop:translate-y-0">
                    <span className="font-medium laptop:text-[24px] text-[16px] text-defaultOrange">
                      Halving
                    </span>
                    <span className="font-normal laptop:text-[18px] text-[14px] text-typographyWhite">
                      Apr-24
                    </span>
                  </div>
                  <div className="translate-y-[-8px] laptop:translate-y-0">
                    <span className="font-medium laptop:text-[24px] text-[16px] text-defaultOrange">
                      Bitcoin Moon
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="_initial_401a9_1">
              <div className="max-w-[630px] mx-auto p-[16px] bg-[#2A1B4D] relative z-10">
                <p className="font-DM_Mono font-normal text-typographyWhite lg:text-[18px] text-base text-center relative">
                  1 coin could hit $1,500,000 according to Cathie Wood, CEO of Ark Invest
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="laptop:py-[160px] py-[64px]">
            <div className="_initial_401a9_1">
              <h2 className="text-defaultOrange font-DM_Mono font-medium lg:text-5xl text-[28px] laptop:mb-[32px] mb-[16px]">
                We support
              </h2>
            </div>
            <div className="_initial_401a9_1">
              <div className="grid laptop:grid-cols-4 tablet:grid-cols-3 grid-cols-2 laptop:gap-[42px] gap-[16px]">
                <div className="relative laptop:p-[24px] p-[12px] laptop:h-[204px] h-[146px] flex flex-col justify-between laptop:shadow-[12px_12px_0_0_rgba(255,255,255,0.03)]">
                  <img
                    alt="Leather Wallet by Trust Machines"
                    className="absolute w-full h-full inset-[0_0_0_0] _Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <div className="laptop:w-[80px] w-[56px]">
                    <img
                      alt="Leather Wallet by Trust Machines"
                      className="relative z-[2] _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                  <p className="font-medium text-typographyWhite laptop:text-[18px] text-[13px] relative z-10">
                    Leather Wallet by Trust Machines
                  </p>
                </div>
                <div className="relative laptop:p-[24px] p-[12px] laptop:h-[204px] h-[146px] flex flex-col justify-between laptop:shadow-[12px_12px_0_0_rgba(255,255,255,0.03)]">
                  <img
                    alt="Xverse"
                    className="absolute w-full h-full inset-[0_0_0_0] _Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <div className="laptop:w-[80px] w-[56px]">
                    <img
                      alt="Xverse"
                      className="relative z-[2] _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                  <p className="font-medium text-typographyWhite laptop:text-[18px] text-[13px] relative z-10">
                    Xverse
                  </p>
                </div>
                <div className="relative laptop:p-[24px] p-[12px] laptop:h-[204px] h-[146px] flex flex-col justify-between laptop:shadow-[12px_12px_0_0_rgba(255,255,255,0.03)]">
                  <img
                    alt="Ryder"
                    className="absolute w-full h-full inset-[0_0_0_0] _Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <div className="laptop:w-[80px] w-[56px]">
                    <img
                      alt="Ryder"
                      className="relative z-[2] _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                  <p className="font-medium text-typographyWhite laptop:text-[18px] text-[13px] relative z-10">
                    Ryder
                  </p>
                </div>
                <div className="relative laptop:p-[24px] p-[12px] laptop:h-[204px] h-[146px] flex flex-col justify-between laptop:shadow-[12px_12px_0_0_rgba(255,255,255,0.03)]">
                  <img
                    alt="Boom Wallet"
                    className="absolute w-full h-full inset-[0_0_0_0] _Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <div className="laptop:w-[80px] w-[56px]">
                    <img
                      alt="Boom Wallet"
                      className="relative z-[2] _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                  <p className="font-medium text-typographyWhite laptop:text-[18px] text-[13px] relative z-10">
                    Boom Wallet
                  </p>
                </div>
                <div className="relative laptop:p-[24px] p-[12px] laptop:h-[204px] h-[146px] flex flex-col justify-between laptop:shadow-[12px_12px_0_0_rgba(255,255,255,0.03)]">
                  <img
                    alt="D'CENT"
                    className="absolute w-full h-full inset-[0_0_0_0] _Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <div className="laptop:w-[80px] w-[56px]">
                    <img
                      alt="D'CENT"
                      className="relative z-[2] _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                  <p className="font-medium text-typographyWhite laptop:text-[18px] text-[13px] relative z-10">
                    D'CENT
                  </p>
                </div>
                <div className="relative laptop:p-[24px] p-[12px] laptop:h-[204px] h-[146px] flex flex-col justify-between laptop:shadow-[12px_12px_0_0_rgba(255,255,255,0.03)]">
                  <img
                    alt="OKX Wallet"
                    className="absolute w-full h-full inset-[0_0_0_0] _Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                  <div className="laptop:w-[80px] w-[56px]">
                    <img
                      alt="OKX Wallet"
                      className="relative z-[2] _Image_blpaf_1"
                      src=""
                      style={{
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                  <p className="font-medium text-typographyWhite laptop:text-[18px] text-[13px] relative z-10">
                    OKX Wallet
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h-[580px] laptop:h-[465px] relative">
          <div className="max-w-full laptop:max-w-[1264px] container">
            <h2 className="absolute top-[24px] laptop:top-[64px] left-[12px] right-[initial] laptop:left-[initial] laptop:right-[0px] text-defaultOrange z-[2] text-[28px] laptop:text-[48px] mb-[12px] font-medium">
              Inspired by
            </h2>
            <div className="px-[12px] absolute top-[70px] laptop:top-[170px] right-[0] laptop:right-[initial] left-[initial] z-[2] max-w-[310px] laptop:max-w-[425px] laptop:left-[430px]">
              <h2 className="mb-[16px] text-right laptop:text-left laptop:mb-[20px] text-[white] text-[20px] laptop:text-[32px] relative">
                <img
                  alt="star"
                  className="laptop:hidden absolute top-[-3px] left-[155px] _animate_4_47x3l_21 _Image_blpaf_1"
                  src=""
                  style={{
                    objectFit: 'contain'
                  }}
                />
                <img
                  alt="star"
                  className="laptop:hidden absolute top-[30px] left-[130px] _animate_3_47x3l_17 _Image_blpaf_1"
                  src=""
                  style={{
                    objectFit: 'contain'
                  }}
                />
                Satoshi{' '}
                <br className="laptop:hidden" />
                {' '}Nakamoto
              </h2>
              <div className="text-right laptop:text-left h-[425px] text-[#D6D6D6] text-[14px] relative laptop:text-[17px]">
                <img
                  alt="star"
                  className="laptop:hidden absolute bottom-[245px] right-[25px] _animate_2_47x3l_13 _Image_blpaf_1"
                  src=""
                  style={{
                    objectFit: 'contain'
                  }}
                />
                <div className="relative">
                  <p className="absolute top-0 left-0 right-0 bottom-0 w-full h-full">
                    n
                  </p>
                  <p className="opacity-0">
                    Hello! My name is Satoshi Nakamoto and I am a real owner of Bitcoin. Many people think that I am dead or that my dad is Albert Einstein, but neither is true. So be alert, a lot of interesting things are waiting for you soon
                  </p>
                </div>
              </div>
            </div>
            <div className="absolute left-0 bottom-0 w-[960px] h-[505px] z-[2] hidden laptop:block">
              <img
                alt="satoshi"
                className="_Image_blpaf_1"
                src=""
                style={{
                  objectFit: 'contain'
                }}
              />
              <img
                alt="star"
                className="absolute left-[446px] top-[150px] _animate_1_47x3l_9 _Image_blpaf_1"
                src=""
                style={{
                  objectFit: 'contain'
                }}
              />
              <img
                alt="star"
                className="absolute top-[189px] right-[40px] _animate_2_47x3l_13 _Image_blpaf_1"
                src=""
                style={{
                  objectFit: 'contain'
                }}
              />
              <img
                alt="star"
                className="absolute top-[222px] right-[10px] _animate_3_47x3l_17 _Image_blpaf_1"
                src=""
                style={{
                  objectFit: 'contain'
                }}
              />
              <img
                alt="star"
                className="absolute bottom-[47px] right-0 _animate_4_47x3l_21 _Image_blpaf_1"
                src=""
                style={{
                  objectFit: 'contain'
                }}
              />
            </div>
            <img
              alt="satoshi"
              className="absolute left-0 bottom-0 w-[256px] h-[290px] z-[2] block laptop:hidden _Image_blpaf_1"
              src=""
              style={{
                objectFit: 'contain'
              }}
            />
          </div>
          <div className="h-auto h-[700px] laptop:h-[465px] absolute left-0 bottom-0 top-0 right-0 overflow-hidden">
            <img
              alt="satoshi"
              className="brightness-[0.3] laptop:brightness-[0.8] absolute left-0 right-0 w-full h-[700px] laptop:h-[560px] object-cover _Image_blpaf_1"
              src=""
              style={{
                objectFit: 'cover'
              }}
            />
          </div>
        </div>
        <div
          className="bg-[#17151E] relative py-[48px] laptop:pt-[140px] laptop:pb-[92px]"
          id="satoshinomics"
        >
          <div className="z-10 container">
            <div className="_initial_401a9_1">
              <h2 className="text-defaultOrange text-[28px] laptop:text-[48px] mb-[16px] laptop:mb-[32px] font-medium laptop:text-center">
                Satoshinomics
              </h2>
            </div>
            <div className="_initial_401a9_1">
              <div className="flex flex-col border border-[#44403C] laptop:grid grid-cols-5">
                <div className="laptop:order-1 order-2 row-span-3 col-span-2 flex justify-center laptop:py-[40px] px-[16px] py-[20px]">
                  <img
                    alt="circle"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </div>
                <div className="order-1 laptop:border-l border-b border-[#44403C] laptop:pt-[34px] py-16px col-span-3">
                  <p className="font-medium text-white text-center laptop:text-[32px] text-[16px] uppercase">
                    TOTAL TOKEN SUPPLY:
                    <br />
                    10,000,000,000
                  </p>
                </div>
                <div className="order-3 laptop:border-l border-t border-[#44403C] row-span-2 col-span-3">
                  <ul className="laptop:pl-[48px] laptop:pr-[48px] laptop:pt-[34px] laptop:pb-[48px] px-[12px] py-[20px] font-medium text-white">
                    <li className="flex justify-between items-center mb-20px">
                      <span className="h-[30px] w-[30px] laptop:h-[36px] laptop:w-[36px] bg-[#DC4F1D]" />
                      <span className="laptop:text-[18px] text-[16px] grow ml-[12px]">
                        Presale
                      </span>
                      <span className="laptop:text-[18px] laptop:inline hidden uppercase text-right mr-[25px]">
                        3,000,000,000 $SATX
                      </span>
                      <span className="laptop:text-[24px] text-[20px] uppercase text-right">
                        30%
                      </span>
                    </li>
                    <li className="flex justify-between items-center mb-20px">
                      <span className="h-[30px] w-[30px] laptop:h-[36px] laptop:w-[36px] bg-[#C88C21]" />
                      <span className="laptop:text-[18px] text-[16px] grow ml-[12px]">
                        Liquidity Provision
                      </span>
                      <span className="laptop:text-[18px] laptop:inline hidden uppercase text-right mr-[25px]">
                        2,500,000,000 $SATX
                      </span>
                      <span className="laptop:text-[24px] text-[20px] uppercase text-right">
                        25%
                      </span>
                    </li>
                    <li className="flex justify-between items-center mb-20px">
                      <span className="h-[30px] w-[30px] laptop:h-[36px] laptop:w-[36px] bg-[#058789]" />
                      <span className="laptop:text-[18px] text-[16px] grow ml-[12px]">
                        Team & Advisors
                      </span>
                      <span className="laptop:text-[18px] laptop:inline hidden uppercase text-right mr-[25px]">
                        1,500,000,000 $SATX
                      </span>
                      <span className="laptop:text-[24px] text-[20px] uppercase text-right">
                        15%
                      </span>
                    </li>
                    <li className="flex justify-between items-center mb-20px">
                      <span className="h-[30px] w-[30px] laptop:h-[36px] laptop:w-[36px] bg-[#85C85C]" />
                      <span className="laptop:text-[18px] text-[16px] grow ml-[12px]">
                        Ecosystem Fund
                      </span>
                      <span className="laptop:text-[18px] laptop:inline hidden uppercase text-right mr-[25px]">
                        1,500,000,000 $SATX
                      </span>
                      <span className="laptop:text-[24px] text-[20px] uppercase text-right">
                        15%
                      </span>
                    </li>
                    <li className="flex justify-between items-center mb-20px">
                      <span className="h-[30px] w-[30px] laptop:h-[36px] laptop:w-[36px] bg-[#5E5CC8]" />
                      <span className="laptop:text-[18px] text-[16px] grow ml-[12px]">
                        Staking
                      </span>
                      <span className="laptop:text-[18px] laptop:inline hidden uppercase text-right mr-[25px]">
                        1,500,000,000 $SATX
                      </span>
                      <span className="laptop:text-[24px] text-[20px] uppercase text-right">
                        15%
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="w-[100%] absolute bottom-0 left-0 z-[1]  tablet:block hidden">
            <img
              alt="grain_background"
              className="w-[100%] _Image_blpaf_1"
              src=""
              style={{
                objectFit: 'contain'
              }}
            />
          </div>
          <div className="w-[100%] absolute bottom-0 left-0 z-[1] tablet:hidden">
            <img
              alt="grain_background"
              className="w-[100%] _Image_blpaf_1"
              src=""
              style={{
                objectFit: 'contain'
              }}
            />
          </div>
        </div>
        <div
          className="bg-[#110F16] relative py-[60px] laptop:py-[90px]"
          id="roadmap"
        >
          <div className="container">
            <h2 className="text-defaultOrange text-[28px] laptop:text-[48px] mb-[16px] laptop:mb-[32px] font-medium">
              Roadmap
            </h2>
            <div className="_initial_401a9_1">
              <div className="flex flex-col laptop:flex-row tablet:flex-row flex-wrap">
                <div className="_card_mobile_s8fqa_12 bg-backgroundGrey laptop:h-[248px] tablet:h-[248px] laptop:w-[248px] tablet:w-[248px] h-[138px] relative">
                  <div className="_card_border_mobile_s8fqa_16 laptop:h-[246px] tablet:h-[246px] h-[136px] laptop:w-[246px] tablet:w-[246px] w-[99.5%] bg-[#110F16]">
                    <div className="h-[100%] p-16px">
                      <div className="h-[100%] flex flex-col justify-between">
                        <h3 className="font-medium text-defaultOrange text-[28px]">
                          [ Q4 ] 2023
                        </h3>
                        <div className="font-medium text-white text-[22px]">
                          <div className="relative">
                            <p className="absolute top-0 left-0 right-0 bottom-0 w-full h-full">
                              h
                            </p>
                            <p className="opacity-0">
                              $SATX Beta Launch
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="_card_mobile_s8fqa_12 bg-backgroundGrey laptop:h-[248px] tablet:h-[248px] laptop:w-[248px] tablet:w-[248px] h-[138px] relative">
                  <div className="_card_border_mobile_s8fqa_16 laptop:h-[246px] tablet:h-[246px] h-[136px] laptop:w-[246px] tablet:w-[246px] w-[99.5%] bg-[#110F16]">
                    <div className="h-[100%] p-16px">
                      <div className="h-[100%] flex flex-col justify-between">
                        <h3 className="font-medium text-defaultOrange text-[28px]">
                          [ Q1 ] 2024
                        </h3>
                        <div className="font-medium text-white text-[22px]">
                          <div className="relative">
                            <p className="absolute top-0 left-0 right-0 bottom-0 w-full h-full">
                              F
                            </p>
                            <p className="opacity-0">
                              BitcoinETF
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="_card_mobile_s8fqa_12 bg-backgroundGrey laptop:h-[248px] tablet:h-[248px] laptop:w-[248px] tablet:w-[248px] h-[138px] relative">
                  <div className="_card_border_mobile_s8fqa_16 laptop:h-[246px] tablet:h-[246px] h-[136px] laptop:w-[246px] tablet:w-[246px] w-[99.5%] bg-[#110F16]">
                    <div className="h-[100%] p-16px">
                      <div className="h-[100%] flex flex-col justify-between">
                        <h3 className="font-medium text-defaultOrange text-[28px]">
                          [ Q2 ] 2024
                        </h3>
                        <div className="font-medium text-white text-[22px]">
                          <div className="relative">
                            <p className="absolute top-0 left-0 right-0 bottom-0 w-full h-full">
                              g
                            </p>
                            <p className="opacity-0">
                              Bitcoin Halving
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="_card_mobile_s8fqa_12 bg-backgroundGrey laptop:h-[248px] tablet:h-[248px] laptop:w-[248px] tablet:w-[248px] h-[138px] relative">
                  <div className="_card_border_mobile_s8fqa_16 laptop:h-[246px] tablet:h-[246px] h-[136px] laptop:w-[246px] tablet:w-[246px] w-[99.5%] bg-[#110F16]">
                    <div className="h-[100%] p-16px">
                      <div className="h-[100%] flex flex-col justify-between">
                        <h3 className="font-medium text-defaultOrange text-[28px]">
                          [ Q3 ] 2024
                        </h3>
                        <div className="font-medium text-white text-[22px]">
                          <div className="relative">
                            <p className="absolute top-0 left-0 right-0 bottom-0 w-full h-full">
                              h
                            </p>
                            <p className="opacity-0">
                              $SATX Ecosystem Growth
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="_card_mobile_s8fqa_12 bg-backgroundGrey laptop:h-[248px] tablet:h-[248px] laptop:w-[248px] tablet:w-[248px] h-[138px] relative">
                  <div className="_card_border_mobile_s8fqa_16 laptop:h-[246px] tablet:h-[246px] h-[136px] laptop:w-[246px] tablet:w-[246px] w-[99.5%] bg-[#110F16]">
                    <div className="h-[100%] p-16px">
                      <div className="h-[100%] flex flex-col justify-between">
                        <h3 className="font-medium text-defaultOrange text-[28px]">
                          [ Q4 ] 2024
                        </h3>
                        <div className="font-medium text-white text-[22px]">
                          <div className="relative">
                            <p className="absolute top-0 left-0 right-0 bottom-0 w-full h-full">
                              .
                            </p>
                            <p className="opacity-0">
                              $BTC & $SATX to the Moon...
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="laptop:pt-[100px] laptop:pb-[120px] pb-[64px]"
          id=""
        >
          <div className="container">
            <div className="flex flex-col gap-[20px] laptop:gap-0 laptop:flex-row justify-between">
              <div className="laptop:basis-[374px] shrink-1 grow-0">
                <h2 className="text-defaultOrange font-DM_Mono font-medium lg:text-5xl text-[28px] mb-[16px]">
                  FAQ
                </h2>
                <p className="text-[16px] laptop:text-[18px] text-[#D6D6D6] font-normal">
                  Satoshi like to help! Reach out to our support teams on any of our social channels. In the meantime, here's some of our FAQs.
                </p>
              </div>
              <div className="laptop:basis-[770px] shrink-1 grow-0">
                <div className="flex flex-col gap-[16px]">
                  <div
                    className="p-[16px] border border-[#44403C]"
                    id=""
                    style={{
                      transition: 'all 0.3s ease 0s'
                    }}
                  >
                    <div
                      className="flex justify-between false"
                      style={{
                        transition: 'all 0.3s ease 0s'
                      }}
                    >
                      <p className="text-[20px] laptop:text-[24px] font-medium text-white basis-[60%] grow-0">
                        Which countries are restricted to participate in the sale?
                      </p>
                      <svg
                        fill="none"
                        height="32"
                        viewBox="0 0 32 32"
                        width="32"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.5 16C28.5 16.3978 28.342 16.7794 28.0607 17.0607C27.7794 17.342 27.3978 17.5 27 17.5H17.5V27C17.5 27.3978 17.342 27.7794 17.0607 28.0607C16.7794 28.342 16.3978 28.5 16 28.5C15.6022 28.5 15.2206 28.342 14.9393 28.0607C14.658 27.7794 14.5 27.3978 14.5 27V17.5H5C4.60218 17.5 4.22064 17.342 3.93934 17.0607C3.65804 16.7794 3.5 16.3978 3.5 16C3.5 15.6022 3.65804 15.2206 3.93934 14.9393C4.22064 14.658 4.60218 14.5 5 14.5H14.5V5C14.5 4.60218 14.658 4.22064 14.9393 3.93934C15.2206 3.65804 15.6022 3.5 16 3.5C16.3978 3.5 16.7794 3.65804 17.0607 3.93934C17.342 4.22064 17.5 4.60218 17.5 5V14.5H27C27.3978 14.5 27.7794 14.658 28.0607 14.9393C28.342 15.2206 28.5 15.6022 28.5 16Z"
                          data-darkreader-inline-fill=""
                          fill="white"
                          style={{
                            '--darkreader-inline-fill': '#f4f2ee'
                          }}
                        />
                      </svg>
                    </div>
                    <div
                      className="_collapse_se0ig_1 _hide_se0ig_6"
                      style={{
                        height: '0px'
                      }}
                    >
                      <div>
                        <p className="text-[16px] laptop:text-[18px] text-[#D6D6D6] font-normal">
                          Unfortunately, we cannot accept participants from the following countries: United States of America (including its territories), Democratic People’s Republic of Korea, Cuba, Syria, Iran, Sudan, Crimea, People’s Republic of China, Bahamas, Botswana, Burundi, Cambodia, Central African Republic, The Democratic Republic of the Congo, Côte d’Ivoire, Cuba, Ethiopia, Ghana, Islamic Republic of Iran, Iraq, Libya, Mali, Myanmar, Somalia, South Sudan, Sri Lanka, Sudan, Syrian Arab Republic, Trinidad and Tobago, Bolivarian Republic of Venezuela, Yemen, and Zimbabwe.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="p-[16px] border border-[#44403C]"
                    id=""
                    style={{
                      transition: 'all 0.3s ease 0s'
                    }}
                  >
                    <div
                      className="flex justify-between false"
                      style={{
                        transition: 'all 0.3s ease 0s'
                      }}
                    >
                      <p className="text-[20px] laptop:text-[24px] font-medium text-white basis-[60%] grow-0">
                        How can I claim the token?
                      </p>
                      <svg
                        fill="none"
                        height="32"
                        viewBox="0 0 32 32"
                        width="32"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.5 16C28.5 16.3978 28.342 16.7794 28.0607 17.0607C27.7794 17.342 27.3978 17.5 27 17.5H17.5V27C17.5 27.3978 17.342 27.7794 17.0607 28.0607C16.7794 28.342 16.3978 28.5 16 28.5C15.6022 28.5 15.2206 28.342 14.9393 28.0607C14.658 27.7794 14.5 27.3978 14.5 27V17.5H5C4.60218 17.5 4.22064 17.342 3.93934 17.0607C3.65804 16.7794 3.5 16.3978 3.5 16C3.5 15.6022 3.65804 15.2206 3.93934 14.9393C4.22064 14.658 4.60218 14.5 5 14.5H14.5V5C14.5 4.60218 14.658 4.22064 14.9393 3.93934C15.2206 3.65804 15.6022 3.5 16 3.5C16.3978 3.5 16.7794 3.65804 17.0607 3.93934C17.342 4.22064 17.5 4.60218 17.5 5V14.5H27C27.3978 14.5 27.7794 14.658 28.0607 14.9393C28.342 15.2206 28.5 15.6022 28.5 16Z"
                          data-darkreader-inline-fill=""
                          fill="white"
                          style={{
                            '--darkreader-inline-fill': '#f4f2ee'
                          }}
                        />
                      </svg>
                    </div>
                    <div
                      className="_collapse_se0ig_1 _hide_se0ig_6"
                      style={{
                        height: '0px'
                      }}
                    >
                      <div>
                        <p className="text-[16px] laptop:text-[18px] text-[#D6D6D6] font-normal">
                          You will be able to claim coins on the BSC network and also on Stacks after TGE. You'll need to manually output them from the platform at the TGE. TGE & Listing will start once Presale finished.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="p-[16px] border border-[#44403C]"
                    id=""
                    style={{
                      transition: 'all 0.3s ease 0s'
                    }}
                  >
                    <div
                      className="flex justify-between false"
                      style={{
                        transition: 'all 0.3s ease 0s'
                      }}
                    >
                      <p className="text-[20px] laptop:text-[24px] font-medium text-white basis-[60%] grow-0">
                        How many rounds SatoshiDEX will have in presale?
                      </p>
                      <svg
                        fill="none"
                        height="32"
                        viewBox="0 0 32 32"
                        width="32"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.5 16C28.5 16.3978 28.342 16.7794 28.0607 17.0607C27.7794 17.342 27.3978 17.5 27 17.5H17.5V27C17.5 27.3978 17.342 27.7794 17.0607 28.0607C16.7794 28.342 16.3978 28.5 16 28.5C15.6022 28.5 15.2206 28.342 14.9393 28.0607C14.658 27.7794 14.5 27.3978 14.5 27V17.5H5C4.60218 17.5 4.22064 17.342 3.93934 17.0607C3.65804 16.7794 3.5 16.3978 3.5 16C3.5 15.6022 3.65804 15.2206 3.93934 14.9393C4.22064 14.658 4.60218 14.5 5 14.5H14.5V5C14.5 4.60218 14.658 4.22064 14.9393 3.93934C15.2206 3.65804 15.6022 3.5 16 3.5C16.3978 3.5 16.7794 3.65804 17.0607 3.93934C17.342 4.22064 17.5 4.60218 17.5 5V14.5H27C27.3978 14.5 27.7794 14.658 28.0607 14.9393C28.342 15.2206 28.5 15.6022 28.5 16Z"
                          data-darkreader-inline-fill=""
                          fill="white"
                          style={{
                            '--darkreader-inline-fill': '#f4f2ee'
                          }}
                        />
                      </svg>
                    </div>
                    <div
                      className="_collapse_se0ig_1 _hide_se0ig_6"
                      style={{
                        height: '0px'
                      }}
                    >
                      <div>
                        <p className="text-[16px] laptop:text-[18px] text-[#D6D6D6] font-normal">
                          We have dedicated allocation of 30% specially for presale. Number of rounds will depend on community preferences and demand. Unsold tokens will be burned.{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="p-[16px] border border-[#44403C]"
                    id="scroll-faq-about-round"
                    style={{
                      transition: 'all 0.3s ease 0s'
                    }}
                  >
                    <div
                      className="flex justify-between false"
                      style={{
                        transition: 'all 0.3s ease 0s'
                      }}
                    >
                      <p className="text-[20px] laptop:text-[24px] font-medium text-white basis-[60%] grow-0">
                        What was the price of previous rounds?
                      </p>
                      <svg
                        fill="none"
                        height="32"
                        viewBox="0 0 32 32"
                        width="32"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.5 16C28.5 16.3978 28.342 16.7794 28.0607 17.0607C27.7794 17.342 27.3978 17.5 27 17.5H17.5V27C17.5 27.3978 17.342 27.7794 17.0607 28.0607C16.7794 28.342 16.3978 28.5 16 28.5C15.6022 28.5 15.2206 28.342 14.9393 28.0607C14.658 27.7794 14.5 27.3978 14.5 27V17.5H5C4.60218 17.5 4.22064 17.342 3.93934 17.0607C3.65804 16.7794 3.5 16.3978 3.5 16C3.5 15.6022 3.65804 15.2206 3.93934 14.9393C4.22064 14.658 4.60218 14.5 5 14.5H14.5V5C14.5 4.60218 14.658 4.22064 14.9393 3.93934C15.2206 3.65804 15.6022 3.5 16 3.5C16.3978 3.5 16.7794 3.65804 17.0607 3.93934C17.342 4.22064 17.5 4.60218 17.5 5V14.5H27C27.3978 14.5 27.7794 14.658 28.0607 14.9393C28.342 15.2206 28.5 15.6022 28.5 16Z"
                          data-darkreader-inline-fill=""
                          fill="white"
                          style={{
                            '--darkreader-inline-fill': '#f4f2ee'
                          }}
                        />
                      </svg>
                    </div>
                    <div
                      className="_collapse_se0ig_1 _hide_se0ig_6"
                      style={{
                        height: '0px'
                      }}
                    >
                      <div>
                        <p className="text-[16px] laptop:text-[18px] text-[#D6D6D6] font-normal">
                          We successfully already finished 8 rounds of presale. The price and amount of sold tokens you can find below:
                          <br />
                          <br />
                          Round 1: $700,000 (482,758,621 $SATX), $0.00145 per 1 $SATX
                          <br />
                          Round 2: $300,000 (200,000,000 $SATX), $0.00150 per 1 $SATX
                          <br />
                          Round 3: $500,000 (297,619,048 $SATX), $0.00168 per 1 $SATX
                          <br />
                          Round 4: $700,000 (362,318,841 $SATX), $0.00193 per 1 $SATX
                          <br />
                          Round 5: $500,000 (226,244,344 $SATX), $0.00221 per 1 $SATX
                          <br />
                          Round 6: $500,000 (174,034,111 $SATX), $0.00287 per 1 $SATX
                          <br />
                          Round 7: $700,000 (162,431,837 $SATX), $0.00431 per 1 $SATX
                          <br />
                          Round 8: $1,000,000 (154,696,987 $SATX), $0.00646 per 1 $SATX
                          <br />
                          Round 9: $1,000,000 (103,131,325 $SATX), $0.00970 per 1 $SATX
                          <br />
                          Round 10: $1,500,000 (118,997,683 $SATX), $0.01261 per 1 $SATX
                          <br />
                          Round 11: $1,700,000 (103,741,569 $SATX), $0.01639 per 1 $SATX
                          <br />
                          Round 12 Coming Soon
                          <br />
                          <br />
                          The total sold allocation including ongoing Round 10 - 22.82% from total supply.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#110F16] relative pt-[56px] pb-[64px] laptop:pb-[120px] laptop:pt-[80px] laptop:pb-[60px] overflow-hidden">
          <div className="bg-[#1F1536] relative overflow-hidden container">
            <div className="lazy-hide w-full w-[330px] laptop:w-[344px] absolute left-[-8.5%] top-0 h-[100%] bg-contain bg-no-repeat mix-blend-hard-light  _rotate_47x3l_25" />
            <div className="lazy-hide w-full w-[330px] laptop:w-[344px] absolute right-[-7.5%] top-0 h-[100%] bg-contain bg-no-repeat bg-right-top mix-blend-hard-light " />
            <div
              className="absolute w-[100%] left-0 top-[12px] overflow-hidden whitespace-nowrap flex flex-nowrap"
              style={{
                direction: 'ltr'
              }}
            >
              <p className="text-[14px] font-medium uppercase text-[#4A3380] text-nowrap animate_running_line">
                Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}
              </p>
              <p className="text-[14px] font-medium uppercase text-[#4A3380] text-nowrap animate_running_line">
                Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}
              </p>
            </div>
            <div className="px-[16px] py-[86px]">
              <h2 className="break-words text-defaultOrange text-[28px] laptop:text-[48px] mb-[16px] laptop:mb-[32px] font-medium tablet:text-center relative">
                <img
                  alt="star"
                  className="hidden tablet:block absolute bottom-[13px] left-[383px] _animate_3_47x3l_17 _Image_blpaf_1"
                  src=""
                  style={{
                    objectFit: 'contain'
                  }}
                />
                <img
                  alt="star"
                  className="hidden tablet:block absolute top-[-10px] right-[33%] _animate_2_47x3l_13 _Image_blpaf_1"
                  src=""
                  style={{
                    objectFit: 'contain'
                  }}
                />
                <img
                  alt="star"
                  className="hidden tablet:block absolute top-[20px] right-[28%] _animate_3_47x3l_17 _Image_blpaf_1"
                  src=""
                  style={{
                    objectFit: 'contain'
                  }}
                />
                Disclaimer
              </h2>
              <p className="laptop:text-[18px] text-[16px] tablet:text-center text-[#D6D6D6] laptop:px-[150px]">
                Disclaimer: Cryptocurrency may be unregulated in your jurisdiction. The value of cryptocurrencies may go down as well as up. Profits may be subject to capital gains or other taxes applicable in your jurisdiction.
              </p>
            </div>
            <div
              className="absolute w-[100%] left-0 bottom-[12px] overflow-hidden whitespace-nowrap flex flex-nowrap"
              style={{
                direction: 'ltr'
              }}
            >
              <p className="text-[14px] font-medium uppercase text-[#4A3380] text-nowrap animate_running_line_reverse">
                Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}
              </p>
              <p className="text-[14px] font-medium uppercase text-[#4A3380] text-nowrap animate_running_line_reverse">
                Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}Disclaimer{' '}
                <span className="inline-block p-[5px] w-[10px] h-[10px] bg-[#4A3380]" />
                {' '}
              </p>
            </div>
          </div>
        </div>
      </main>
      <footer className="flex items-center justify-center bg-[#17151E] pt-[32px] laptop:pt-[42px] pb-[37px] relative min-h-[262px] overflow-hidden">
        <img
          alt="[]"
          className="w-full mobile:w-auto absolute left-[50%] translate-x-[-50%] laptop:translate-x-[0] laptop:left-[20%] bottom-0 _Image_blpaf_1"
          src=""
          style={{
            objectFit: 'contain'
          }}
        />
        <div className="hidden laptop:block absolute right-[20%] bottom-0">
          <img
            alt="[]"
            className="absolute left-[-40px] top-[30px] _Image_blpaf_1"
            src=""
            style={{
              objectFit: 'contain'
            }}
          />
          <img
            alt="[]"
            className="_Image_blpaf_1"
            src=""
            style={{
              objectFit: 'contain'
            }}
          />
        </div>
        <div className="container">
          <div className="flex flex-col laptop:flex-row justify-between">
            <div className="flex flex-col">
              <div className="flex flex-col laptop:flex-row items-center">
                <img
                  alt="[]"
                  className="self-center laptop:self-start max-w-[38px] _Image_blpaf_1"
                  src=""
                  style={{
                    objectFit: 'contain'
                  }}
                />
              </div>
              <div className="flex gap-[24px] mt-[32px] laptop:mt-[28px] justify-center items-center laptop:justify-start">
                <a
                  className="_slink_1p8j9_15"
                  href="https://x.com/satoshiDEX_ai"
                  target="_blank"
                >
                  <img
                    alt="[]"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </a>
                <a
                  className="_slink_1p8j9_15"
                  href="https://t.me/SatoshiDEXAI"
                  target="_blank"
                >
                  <img
                    alt="[]"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </a>
                <a
                  className="_slink_1p8j9_15"
                  href="mailto:contact@satoshidex.ai"
                  target="_blank"
                >
                  <img
                    alt="[]"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </a>
                <a
                  className="_slink_1p8j9_15"
                  href="https://github.com/plutosurfingtrailtea/contracts"
                  target="_blank"
                >
                  <img
                    alt="[]"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </a>
                <a
                  className="hidden laptop:block ml-[22px]"
                  href="https://satoshidex.ai/audit.pdf"
                  target="_blank"
                >
                  <img
                    alt="[]"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </a>
                <a
                  className="hidden laptop:block w-[72px] h-[72px]"
                  href="https://github.com/0xGuard-com/audit-reports/blob/master/SatoshiDEX%20Token/SatoshiDEX%20Token.pdf"
                  target="_blank"
                >
                  <img
                    alt="[]"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </a>
              </div>
              <div className="w-full laptop:w-auto grid grid-cols-2 gap-[16px] my-[32px] laptop:mt-[40px] laptop:mb-0">
                <a
                  className="_link_1p8j9_1 break-words"
                  href="/terms"
                >
                  Terms
                </a>
                <a
                  className="_link_1p8j9_1 break-words"
                  href="/privacy"
                >
                  Privacy
                </a>
              </div>
              <div className="laptop:hidden flex justify-between items-center mb-[32px]">
                <a
                  className="max-w-[198px]"
                  href="https://satoshidex.ai/audit.pdf"
                  target="_blank"
                >
                  <img
                    alt="[]"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </a>
                <a
                  className="w-[72px] h-[72px]"
                  href="https://github.com/0xGuard-com/audit-reports/blob/master/SatoshiDEX%20Token/SatoshiDEX%20Token.pdf"
                  target="_blank"
                >
                  <img
                    alt="[]"
                    className="_Image_blpaf_1"
                    src=""
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </a>
              </div>
            </div>
            <div className="text-center laptop:text-right flex flex-col justify-end laptop:items-end">
              <span className="text-center opacity-[0.75] text-[14px] text-white">
                © 2024 SATOSHI All Rights Reserved.
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <onboard-v2
    style={{
      all: 'initial'
    }}
   />
  <style
    dangerouslySetInnerHTML={{
      __html: '      @font-face {      font-family: \'Inter\';      font-style:  normal;      font-weight: 300 600;      font-display: swap;      src: url("https://rsms.me/inter/font-files/Inter-roman.var.woff2?v=3.19") format("woff2");      }   '
    }}
   />
</div>
</>

  );
}

export default Erred;
